import type { ContentItem } from '../contentLibrary'

export const TANG_ARTICLES: ContentItem[] = [
  {
    id: 'poem-jingyesi',
    category: 'poem',
    dynasty: 'tang',
    title: '靜夜思',
    source: '李白',
    description: '經典五言絕句，適合入門抄寫。',
    content: '床前明月光，疑是地上霜。舉頭望明月，低頭思故鄉。',
  },

  {
    id: 'poem-chunxiao',
    category: 'poem',
    dynasty: 'tang',
    title: '春曉',
    source: '孟浩然',
    description: '四句短詩，字數均衡。',
    content: '春眠不覺曉，處處聞啼鳥。夜來風雨聲，花落知多少。',
  },

  {
    id: 'poem-jiangjinjiu',
    category: 'poem',
    dynasty: 'tang',
    title: '將進酒',
    source: '李白',
    description: '李白代表作，豪邁奔放，宣洩懷才不遇的情懷。',
    content: '君不見黃河之水天上來，奔流到海不復回。君不見高堂明鏡悲白髮，朝如青絲暮成雪。人生得意須盡歡，莫使金樽空對月。天生我材必有用，千金散盡還復來。烹羊宰牛且爲樂，會須一飲三百杯。岑夫子，丹丘生，將進酒，杯莫停。與君歌一曲，請君爲我傾耳聽。鐘鼓饌玉不足貴，但願長醉不復醒。古來聖賢皆寂寞，惟有飲者留其名。陳王昔時宴平樂，斗酒十千恣歡謔。主人何爲言少錢，徑須沽取對君酌。五花馬、千金裘，呼兒將出換美酒，與爾同銷萬古愁。',
  },

  {
    id: 'poem-denggao',
    category: 'poem',
    dynasty: 'tang',
    title: '登高',
    source: '杜甫',
    description: '被譽為「七律之冠」，描寫深秋登高的悲涼心境。',
    content: '風急天高猿嘯哀，渚清沙白鳥飛回。無邊落木蕭蕭下，不盡長江滾滾來。萬里悲秋常作客，百年多病獨登臺。艱難苦恨繁霜鬢，潦倒新停濁酒杯。',
  },

  {
    id: 'poem-shanjuqiuming',
    category: 'poem',
    dynasty: 'tang',
    title: '山居秋暝',
    source: '王維',
    description: '王維山水田園詩代表作，描寫雨後秋山幽靜清冽的自然景色。',
    content: '空山新雨後，天氣晚來秋。明月松間照，清泉石上流。竹喧歸浣女，蓮動下漁舟。隨意春芳歇，王孫自可留。',
  },

  {
    id: 'poem-fengqiaoyebo',
    category: 'poem',
    dynasty: 'tang',
    title: '楓橋夜泊',
    source: '張繼',
    description: '描寫江南秋夜幽美孤寂的旅途景色與客愁。',
    content: '月落烏啼霜滿天，江楓漁火對愁眠。姑蘇城外寒山寺，夜半鐘聲到客船。',
  },

  {
    id: 'poem-wanglu',
    category: 'poem',
    dynasty: 'tang',
    title: '望廬山瀑布',
    source: '李白',
    description: '李白浪漫主義風格的經典山水詩，氣勢磅礡。',
    content: '日照香爐生紫煙，遙看瀑布掛前川。飛流直下三千尺，疑是銀河落九天。',
  },

  {
    id: 'poem-zaofabaidicheng',
    category: 'poem',
    dynasty: 'tang',
    title: '早發白帝城',
    source: '李白',
    description: '描寫長江三峽的壯麗風光與順流而下的暢快心情。',
    content: '朝辭白帝彩雲間，千里江陵一日還。兩岸猿聲啼不住，輕舟已過萬重山。',
  },

  {
    id: 'poem-chunwang',
    category: 'poem',
    dynasty: 'tang',
    title: '春望',
    source: '杜甫',
    description: '杜甫在安史之亂期間所作，憂國憂家之情溢於言表。',
    content: '國破山河在，城春草木深。感時花濺淚，恨別鳥驚心。烽火連三月，家書抵萬金。白頭搔更短，渾欲不勝簪。',
  },

  {
    id: 'poem-chusai',
    category: 'poem',
    dynasty: 'tang',
    title: '出塞',
    source: '王昌齡',
    description: '邊塞詩名篇，感嘆將帥無能、戰士久戍之苦。',
    content: '秦時明月漢時關，萬里長征人未還。但使龍城飛將在，不教胡馬度陰山。',
  },

  {
    id: 'poem-liangzhouci',
    category: 'poem',
    dynasty: 'tang',
    title: '涼州詞',
    source: '王翰',
    description: '邊塞詩中的豪放之作，寫征戰之前的灑脫與悲壯。',
    content: '葡萄美酒夜光杯，欲飲琵琶馬上催。醉臥沙場君莫笑，古來征戰幾人回？',
  },

  {
    id: 'poem-wuyiti',
    category: 'poem',
    dynasty: 'tang',
    title: '無題',
    source: '李商隱',
    description: '李商隱最著名的愛情詩，以「春蠶到死絲方盡」喻情深義重。',
    content: '相見時難別亦難，東風無力百花殘。春蠶到死絲方盡，蠟炬成灰淚始乾。曉鏡但愁雲鬢改，夜吟應覺月光寒。蓬萊此去無多路，青鳥殷勤為探看。',
  },

  {
    id: 'classic-loushimi',
    category: 'classic',
    dynasty: 'tang',
    title: '陋室銘',
    source: '劉禹錫',
    description: '駢文佳作，借讚美陋室抒發高潔傲岸的情操與安貧樂道的志趣。',
    content: '山不在高，有仙則名。水不在深，有龍則靈。斯是陋室，惟吾德馨。苔痕上階綠，草色入簾青。談笑有鴻儒，往來無白丁。可以調素琴，閱金經。無絲竹之亂耳，無案牘之勞形。南陽諸葛廬，西蜀子雲亭。孔子云：何陋之有？',
  },

  {
    id: 'classic-shishuo',
    category: 'classic',
    dynasty: 'tang',
    title: '師說',
    source: '韓愈',
    description: '韓愈論說文名篇，闡明從師學習的重要，文氣縱橫。',
    content: '古之學者必有師。師者，所以傳道受業解惑也。人非生而知之者，孰能無惑？惑而不從師，其為惑也，終不解矣。生乎吾前，其聞道也固先乎吾，吾從而師之；生乎吾後，其聞道也亦先乎吾，吾從而師之。吾師道也，夫庸知其年之先後生於吾乎？是故無貴無賤，無長無少，道之所存，師之所存也。嗟乎！師道之不傳也久矣！欲人之無惑也難矣！古之聖人，其出人也遠矣，猶且從師而問焉；今之眾人，其下人也亦遠矣，而恥學於師。是故聖益聖，愚益愚。聖人之所以為聖，愚人之所以為愚，其皆出於此乎？愛其子，擇師而教之；於其身也，則恥師焉，惑矣。彼童子之師，授之書而習其句讀者，非吾所謂傳其道解其惑者也。句讀之不知，惑之不解，或師焉，或不焉，小學而大遺，吾未見其明也。巫醫樂師百工之人，不恥相師。士大夫之族，曰師曰弟子雲者，則群聚而笑之。問之，則曰：「彼與彼年相若也，道相似也。位卑則足羞，官盛則近諛。」嗚呼！師道之不復可知矣。巫醫樂師百工之人，君子不齒，今其智乃反不能及，其可怪也歟！聖人無常師。孔子師郯子、支弘、師襄、老聃。郯子之徒，其賢不及孔子。孔子曰：三人行，則必有我師。是故弟子不必不如師，師不必賢於弟子，聞道有先後，術業有專攻，如是而已。李氏子蟠，年十七，好古文，六藝經傳皆通習之，不拘於時，學於余。余嘉其能行古道，作《師說》以貽之。',
  },

  {
    id: 'poem-xinglunan',
    category: 'poem',
    dynasty: 'tang',
    title: '行路難',
    source: '李白',
    description: '李白借行路之難抒發壯志未酬的悲憤與自信。',
    content: '金樽清酒斗十千，玉盤珍羞直萬錢。停杯投箸不能食，拔劍四顧心茫然。欲渡黃河冰塞川，將登太行雪滿山。閑來垂釣碧溪上，忽復乘舟夢日邊。行路難，行路難，多歧路，今安在？長風破浪會有時，直掛雲帆濟滄海。',
  },

  {
    id: 'poem-songyouren',
    category: 'poem',
    dynasty: 'tang',
    title: '送友人',
    source: '李白',
    description: '李白送別詩名篇，意境開闊而情意綿長。',
    content: '青山橫北郭，白水繞東城。此地一為別，孤蓬萬里征。浮雲遊子意，落日故人情。揮手自茲去，蕭蕭班馬鳴。',
  },

  {
    id: 'poem-huanghelou',
    category: 'poem',
    dynasty: 'tang',
    title: '黃鶴樓送孟浩然之廣陵',
    source: '李白',
    description: '李白在黃鶴樓送別孟浩然，意境優美。',
    content: '故人西辭黃鶴樓，煙花三月下揚州。孤帆遠影碧空盡，唯見長江天際流。',
  },

  {
    id: 'poem-zengwanglun',
    category: 'poem',
    dynasty: 'tang',
    title: '贈汪倫',
    source: '李白',
    description: '李白即興贈別詩，情感真摯動人。',
    content: '李白乘舟將欲行，忽聞岸上踏歌聲。桃花潭水深千尺，不及汪倫送我情。',
  },

  {
    id: 'poem-duzuojingtingshan',
    category: 'poem',
    dynasty: 'tang',
    title: '獨坐敬亭山',
    source: '李白',
    description: '李白孤獨心境與山水相融的絕句。',
    content: '眾鳥高飛盡，孤雲獨去閑。相看兩不厭，只有敬亭山。',
  },

  {
    id: 'poem-yuexiaoduzhuo',
    category: 'poem',
    dynasty: 'tang',
    title: '月下獨酌',
    source: '李白',
    description: '李白月下獨飲，想像奇絕，曠達超逸。',
    content: '花間一壺酒，獨酌無相親。舉杯邀明月，對影成三人。月既不解飲，影徒隨我身。暫伴月將影，行樂須及春。我歌月徘徊，我舞影零亂。醒時同交歡，醉後各分散。永結無情遊，相期邈雲漢。',
  },

  {
    id: 'poem-wangtianmenshan',
    category: 'poem',
    dynasty: 'tang',
    title: '望天門山',
    source: '李白',
    description: '李白描寫天門山壯麗景色，氣勢雄渾。',
    content: '天門中斷楚江開，碧水東流至此回。兩岸青山相對出，孤帆一片日邊來。',
  },

  {
    id: 'poem-wangyue',
    category: 'poem',
    dynasty: 'tang',
    title: '望岳',
    source: '杜甫',
    description: '杜甫早年名作，寫泰山之雄與抱負之高。',
    content: '岱宗夫如何？齊魯青未了。造化鍾神秀，陰陽割昏曉。盪胸生曾雲，決眥入歸鳥。會當凌絕頂，一覽眾山小。',
  },

  {
    id: 'poem-jueju',
    category: 'poem',
    dynasty: 'tang',
    title: '絕句',
    source: '杜甫',
    description: '杜甫在成都草堂所作，寫景明麗，對仗工整。',
    content: '兩個黃鸝鳴翠柳，一行白鷺上青天。窗含西嶺千秋雪，門泊東吳萬里船。',
  },

  {
    id: 'poem-chunyexiyu',
    category: 'poem',
    dynasty: 'tang',
    title: '春夜喜雨',
    source: '杜甫',
    description: '杜甫詠雨名篇，細膩傳神。',
    content: '好雨知時節，當春乃發生。隨風潛入夜，潤物細無聲。野徑雲俱黑，江船火獨明。曉看紅濕處，花重錦官城。',
  },

  {
    id: 'poem-wenguanjun',
    category: 'poem',
    dynasty: 'tang',
    title: '聞官軍收河南河北',
    source: '杜甫',
    description: '杜甫平生第一快詩，聽聞收復失地後欣喜若狂。',
    content: '劍外忽傳收薊北，初聞涕淚滿衣裳。卻看妻子愁何在，漫卷詩書喜欲狂。白日放歌須縱酒，青春作伴好還鄉。即從巴峽穿巫峽，便下襄陽向洛陽。',
  },

  {
    id: 'poem-lvyeshuhuai',
    category: 'poem',
    dynasty: 'tang',
    title: '旅夜書懷',
    source: '杜甫',
    description: '杜甫晚年漂泊途中，感懷身世之作。',
    content: '細草微風岸，危檣獨夜舟。星垂平野闊，月湧大江流。名豈文章著，官應老病休。飄飄何所似，天地一沙鷗。',
  },

  {
    id: 'poem-jiangnandao',
    category: 'poem',
    dynasty: 'tang',
    title: '江南逢李龜年',
    source: '杜甫',
    description: '杜甫與李龜年重逢，感嘆世事滄桑。',
    content: '岐王宅裡尋常見，崔九堂前幾度聞。正是江南好風景，落花時節又逢君。',
  },

  {
    id: 'poem-yueyeyishe',
    category: 'poem',
    dynasty: 'tang',
    title: '月夜憶舍弟',
    source: '杜甫',
    description: '杜甫在安史之亂中思念弟弟，深情悲切。',
    content: '戍鼓斷人行，邊秋一雁聲。露從今夜白，月是故鄉明。有弟皆分散，無家問死生。寄書長不達，況乃未休兵。',
  },

  {
    id: 'poem-zenghuaqing',
    category: 'poem',
    dynasty: 'tang',
    title: '贈花卿',
    source: '杜甫',
    description: '杜甫讚美音樂之妙，暗含諷喻。',
    content: '錦城絲管日紛紛，半入江風半入雲。此曲只應天上有，人間能得幾回聞。',
  },

  {
    id: 'poem-shuxiang',
    category: 'poem',
    dynasty: 'tang',
    title: '蜀相',
    source: '杜甫',
    description: '杜甫謁諸葛亮祠堂，緬懷先賢，感慨萬千。',
    content: '丞相祠堂何處尋，錦官城外柏森森。映階碧草自春色，隔葉黃鸝空好音。三顧頻煩天下計，兩朝開濟老臣心。出師未捷身先死，長使英雄淚滿襟。',
  },

  {
    id: 'poem-luzhai',
    category: 'poem',
    dynasty: 'tang',
    title: '鹿柴',
    source: '王維',
    description: '空山不見人，但聞人語響，禪意十足。',
    content: '空山不見人，但聞人語響。返景入深林，復照青苔上。',
  },

  {
    id: 'poem-niaomingjian',
    category: 'poem',
    dynasty: 'tang',
    title: '鳥鳴澗',
    source: '王維',
    description: '王維山水詩代表作，以動襯靜。',
    content: '人閒桂花落，夜靜春山空。月出驚山鳥，時鳴春澗中。',
  },

  {
    id: 'poem-zhuliguan',
    category: 'poem',
    dynasty: 'tang',
    title: '竹里館',
    source: '王維',
    description: '王維獨坐竹林彈琴長嘯，意境清幽。',
    content: '獨坐幽篁裡，彈琴復長嘯。深林人不知，明月來相照。',
  },

  {
    id: 'poem-xiangsi',
    category: 'poem',
    dynasty: 'tang',
    title: '相思',
    source: '王維',
    description: '以紅豆寄相思，千古傳誦。',
    content: '紅豆生南國，春來發幾枝。願君多採擷，此物最相思。',
  },

  {
    id: 'poem-songyuaner',
    category: 'poem',
    dynasty: 'tang',
    title: '送元二使安西',
    source: '王維',
    description: '王維著名的送別詩，譜曲後稱「陽關三疊」。',
    content: '渭城朝雨浥輕塵，客舍青青柳色新。勸君更盡一杯酒，西出陽關無故人。',
  },

  {
    id: 'poem-jiuyuejiu',
    category: 'poem',
    dynasty: 'tang',
    title: '九月九日憶山東兄弟',
    source: '王維',
    description: '重陽佳節思鄉之作，感人至深。',
    content: '獨在異鄉為異客，每逢佳節倍思親。遙知兄弟登高處，遍插茱萸少一人。',
  },

  {
    id: 'poem-shizhisai',
    category: 'poem',
    dynasty: 'tang',
    title: '使至塞上',
    source: '王維',
    description: '王維出使邊塞所作，「大漠孤煙直」雄渾壯闊。',
    content: '單車欲問邊，屬國過居延。征蓬出漢塞，歸雁入胡天。大漠孤煙直，長河落日圓。蕭關逢候騎，都護在燕然。',
  },

  {
    id: 'poem-zashi',
    category: 'poem',
    dynasty: 'tang',
    title: '雜詩',
    source: '王維',
    description: '王維思鄉小品，以寒梅寄情。',
    content: '君自故鄉來，應知故鄉事。來日綺窗前，寒梅著花未？',
  },

  {
    id: 'poem-zhongnanbieye',
    category: 'poem',
    dynasty: 'tang',
    title: '終南別業',
    source: '王維',
    description: '王維晚年隱居終南山，悠然自得。',
    content: '中歲頗好道，晚家南山陲。興來每獨往，勝事空自知。行到水窮處，坐看雲起時。偶然值林叟，談笑無還期。',
  },

  {
    id: 'poem-tianyuanle',
    category: 'poem',
    dynasty: 'tang',
    title: '田園樂',
    source: '王維',
    description: '王維田園詩，色彩明麗，閒適安逸。',
    content: '桃紅復含宿雨，柳綠更帶朝煙。花落家童未掃，鶯啼山客猶眠。',
  },

  {
    id: 'poem-guofengji',
    category: 'poem',
    dynasty: 'tang',
    title: '過故人莊',
    source: '孟浩然',
    description: '孟浩然田園詩代表作，清新自然。',
    content: '故人具雞黍，邀我至田家。綠樹村邊合，青山郭外斜。開軒面場圃，把酒話桑麻。待到重陽日，還來就菊花。',
  },

  {
    id: 'poem-sujian',
    category: 'poem',
    dynasty: 'tang',
    title: '宿建德江',
    source: '孟浩然',
    description: '孟浩然寫羈旅之愁，情景交融。',
    content: '移舟泊煙渚，日暮客愁新。野曠天低樹，江清月近人。',
  },

  {
    id: 'poem-wangdongting',
    category: 'poem',
    dynasty: 'tang',
    title: '望洞庭湖贈張丞相',
    source: '孟浩然',
    description: '孟浩然干謁詩，以觀洞庭喻求仕之心。',
    content: '八月湖水平，涵虛混太清。氣蒸雲夢澤，波撼岳陽城。欲濟無舟楫，端居恥聖明。坐觀垂釣者，徒有羨魚情。',
  },

  {
    id: 'classic-jinxuejie',
    category: 'classic',
    dynasty: 'tang',
    title: '進學解（全文）',
    source: '韓愈',
    description: '韓愈勉勵學生勤學，業精於勤荒於嬉。',
    content: '國子先生晨入太學，招諸生立館下，誨之曰：「業精於勤，荒於嬉；行成於思，毀於隨。方今聖賢在上，治具畢張，伺科取士，唯賢是求。拔去凶邪，登用俊傑。占小善者率以錄，名一藝者無不庸。爬羅剔抉，刮垢磨光。蓋有幸而獲選，孰云無路而往？諸生業患不能精，無患科員之不欲收；行患不能成，無患八司之不子知。」言未既，有笑於列者曰：「先生欺我哉！弟子事先生，於茲有年矣。先生口不絕吟於六藝之文，手不停披於百家之編。紀事者必提其要，纂言者必鉤其玄。貪多務得，細大不捐。焚膏油以繼晷，恆兀兀以窮年。先生之業，可謂勤矣。觝排異端，攘斥佛老。補苕罅漏，支撐大廈。尋墜緒之茫茫，獨旁搜而遠紹。障百川而東之，回狂瀾於既倒。先生之志，可謂大矣。然而公不見信於人，私不見助於友。跋前躓後，動輒得咎。暫為御史，遂竄南荒。三年博士，冗不見治。命與仇謀，取敗幾時。冬暖無衣，夏飢無食。頭童齒豁，竟死何裨？不知慮此，而反教人！」先生曰：「吁，子來！前。夫赤木以尋丈為棟梁，小以尺角為接櫞。杙栭櫨栭，唯器所適。玉衡角斗，玉佩珩璜。大合百樂，細入琴笙。此梓匠輪輿，執事者之任也。大木為棟，細木為柴。水有小大，唯舟是容。博施濟眾，賢者所難。今先生處博士之位，口授弟子，手執簡冊。仰不愧於天，俯不怍於人。仕宦不達，命也，何足怪乎！」',
  },

  {
    id: 'classic-mashuo',
    category: 'classic',
    dynasty: 'tang',
    title: '馬說',
    source: '韓愈',
    description: '韓愈借千里馬喻人才，感嘆伯樂難遇。',
    content: '世有伯樂，然後有千里馬。千里馬常有，而伯樂不常有。故雖有名馬，祇辱於奴隸人之手，駢死於槽櫪之間，不以千里稱也。馬之千里者，一食或盡粟一石。食馬者不知其能千里而食也。是馬也，雖有千里之能，食不飽，力不足，才美不外見，且欲與常馬等不可得，安求其能千里也。策之不以其道，食之不能盡其材，鳴之而不能通其意，執策而臨之曰：「天下無馬。」嗚呼！其真無馬邪？其真不知馬也！',
  },

  {
    id: 'classic-xishanyanji',
    category: 'classic',
    dynasty: 'tang',
    title: '始得西山宴遊記',
    source: '柳宗元',
    description: '柳宗元永州八記之首，寫發現西山之喜與超然物外之樂。',
    content: '自余為僇人，居是州，恆惴慄。其隙也，則施施而行，漫漫而遊。日與其徒上高山，入深林，窮回溪，幽泉怪石，無遠不到。到則披草而坐，傾壺而醉。醉則更相枕以臥，臥而夢。意有所極，夢亦同趣。覺而起，起而歸。以為凡是州之山水，有異態者，皆我有也，而未始知西山之怪特。今年九月二十八日，因坐法華西亭，望西山，始指異之。遂命僕人過湘江，緣染溪，斫榛莽，焚茅茷，窮山之高而止。攀援而登，箕踞而遨，則凡數州之土壤，皆在衽席之下。其高下之勢，岈然窪然，若垤若穴，尺寸千里，攢蹙累積，莫得遁隱。縈青繚白，外與天際，四望如一。然後知是山之特立，不與培塿為類。悠悠乎與顥氣俱，而莫得其涯；洋洋乎與造物者遊，而不知其所窮。引觴滿酌，頹然就醉，不知日之入。蒼然暮色，自遠而至，至無所見，而難可留也。反而登舟，放乎中流，與萬化冥合。然後知吾嚮之未始遊，遊於是乎始。故為之文以志。',
  },

  {
    id: 'classic-bushezhe',
    category: 'classic',
    dynasty: 'tang',
    title: '捕蛇者說',
    source: '柳宗元',
    description: '柳宗元借捕蛇者之口，揭露賦稅之毒甚於蛇。',
    content: '永州之野產異蛇，黑質而白章。觸草木，盡死；以齧人，無禦之者。然得而腊之以為餌，可以已大風、攣踠、瘻、癘，去死肌，殺三蟲。其始，太醫以王命聚之，歲賦其二，募有能捕之者，當其租入。永之人爭奔走焉。余問之，則曰：「吾祖死於是，吾父死於是。今吾嗣步驟九年，幾死者數矣。」言之，貌若甚戚者。余哀之，且曰：「若毒之乎？余將告於蒞事者，更若役，復若賦，則何如？」蔣氏大戚，汪然出涕曰：「君將哀而生之乎？則吾斯役之不幸，未若復吾賦不幸之甚也。向吾不為斯役，則久已病矣。自吾氏三世居是鄉，積於今六十歲矣，而鄉鄰之生日蹙。殫其地之出，竭其廬之入，哭泣無聲，徙轉死亡。非死則徙爾，而吾以捕蛇獨存。悍吏之來吾鄉，叫囂乎東西，隳突乎南北，譁然而駭者，雖雞狗不得寧焉。吾洵洵而起，視其缶，而吾蛇尚存，則弛然而臥。謹食之，時而獻焉。退而甘食其土之有，以盡吾齒。蓋一歲之犯死者二焉；其餘，則熙熙而樂。豈若吾鄉鄰之旦旦有是哉！今雖死乎此，比吾鄉鄰之死則已後矣，又安敢毒耶？」余聞而愈悲。孔子曰：「苛政猛於虎也。」吾嘗疑乎是，今以蔣氏觀之，猶信。嗚呼！孰知賦斂之毒有甚是蛇者乎！故為之說，以俟夫觀人風者得焉。',
  },

  {
    id: 'poem-jiangxue',
    category: 'poem',
    dynasty: 'tang',
    title: '江雪',
    source: '柳宗元',
    description: '柳宗元貶謫永州之作，孤獨高潔，意境清絕。',
    content: '千山鳥飛絕，萬徑人蹤滅。孤舟簑笠翁，獨釣寒江雪。',
  },

  {
    id: 'classic-efanggongfu',
    category: 'classic',
    dynasty: 'tang',
    title: '阿房宮賦',
    source: '杜牧',
    description: '杜牧借秦建阿房宮之奢靡，諷諫當朝統治者愛惜民力。',
    content: '六王畢，四海一；蜀山兀，阿房出。覆壓三百餘里，隔離天日。驪山北構而西折，直走咸陽。二川溶溶，流入宮牆。五步一樓，十步一閣；廊腰縵迴，簷牙高啄；各抱地勢，鉤心鬥角。盤盤焉，囷囷焉，蜂房水渦，矗不知乎幾千萬落。長橋臥波，未雲何龍？複道行空，不霽何虹？高低冥迷，不知西東。歌臺暖響，春光融融；舞殿冷袖，風雨淒淒。一日之內，一宮之間，而氣候不齊。妃嬪媵嫱，王子皇孫，辭樓下殿，輦來於秦。朝歌夜絃，為秦宮人。明星熒熒，開妝鏡也；綠雲擾擾，梳曉鬟也；渭流漲膩，棄脂水也；煙斜霧橫，焚椒蘭也。雷霆乍驚，宮車過也；轆轆遠聽，杳不知其所之也。一肌一容，盡態極妍，縟妝麗服，立侍盼睞，員員而望幸焉。有不得見者，三十六年。秦愛紛奢，人亦念其家。奈何取之盡錙銖，用之如泥沙？使負棟之柱，多於南畝之農夫；架梁之椽，多於機上之工女；釘頭磷磷，多於在庾之粟粒；瓦縫參差，多於周身之帛縷；直欄橫檻，多於九土之城郭；管絃嘔啞，多於市井之言語。使天下之人，不敢言而敢怒。獨夫之心，日益驕固。戍卒叫，函谷舉，楚人一炬，可憐焦土！嗚呼！滅六國者六國也，非秦也；族秦者秦也，非天下也。嗟乎！使六國各愛其人，則足以拒秦；使秦復愛東道六國之人，則遞三世可至萬世而為君，誰得而族滅也？秦人不暇自哀，而後人哀之；後人哀之而不鑑之，亦使後人而復哀後人也。',
  },

  {
    id: 'classic-tengwanggexu',
    category: 'classic',
    dynasty: 'tang',
    title: '滕王閣序',
    source: '王勃',
    description: '王勃駢文巔峰之作，落霞與孤鶩齊飛，秋水共長天一色，為歷代書家必寫名篇。',
    content: '豫章故郡，洪都新府。星分翼軫，地接衡廬。襟三江而帶五湖，控蠻荊而引甌越。物華天寶，龍光射牛斗之墟；人傑地靈，徐孺下陳蕃之榻。雄州霧列，俊采星馳。臺隍枕夷夏之交，賓主盡東南之美。都督閻公之雅望，棨戟遙臨；宇文新州之懿範，襜帷暫駐。十旬休假，勝友如雲；千里逢迎，高朋滿座。騰蛟起鳳，孟學士之詞宗；紫電青霜，王將軍之武庫。家君作宰，路出名區；童子何知，躬逢勝餞。\n時維九月，序屬三秋。潦水盡而寒潭清，煙光凝而暮山紫。儼驂騑於上路，訪風景於崇阿。臨帝子之長洲，得天人之舊館。層巒聳翠，上出重霄；飛閣流丹，下臨無地。鶴汀鳧渚，窮島嶼之縈迴；桂殿蘭宮，即岡巒之體勢。披繡闥，俯雕甍，山原曠其盈視，川澤紆其駭矚。閭閻撲地，鍾鳴鼎食之家；舸艦迷津，青雀黃龍之舳。雲銷雨霽，彩徹區明。落霞與孤鶩齊飛，秋水共長天一色。漁舟唱晚，響窮彭蠡之濱；雁陣驚寒，聲斷衡陽之浦。\n遙襟甫暢，逸興遄飛。爽籟發而清風生，纖歌凝而白雲遏。睢園綠竹，氣凌彭澤之樽；鄴水朱華，光照臨川之筆。四美具，二難并。窮睇眄於中天，極娛遊於暇日。天高地迥，覺宇宙之無窮；興盡悲來，識盈虛之有數。望長安於日下，目吳會於雲間。地勢極而南溟深，天柱高而北辰遠。關山難越，誰悲失路之人？萍水相逢，盡是他鄉之客。懷帝閽而不見，奉宣室以何年？\n嗟乎！時運不齊，命途多舛。馮唐易老，李廣難封。屈賈誼於長沙，非無聖主；竄梁鴻於海曲，豈乏明時？所賴君子見機，達人知命。老當益壯，寧移白首之心？窮且益堅，不墜青雲之志。酌貪泉而覺爽，處涸轍以猶歡。北海雖賒，扶搖可接；東隅已逝，桑榆非晚。孟嘗高潔，空餘報國之情；阮籍猖狂，豈效窮途之哭！\n勃，三尺微命，一介書生。無路請纓，等終軍之弱冠；有懷投筆，慕宗慤之長風。舍簪笏於百齡，奉晨昏於萬里。非謝家之寶樹，接孟氏之芳鄰。他日趨庭，叨陪鯉對；今茲捧袂，喜託龍門。楊意不逢，撫凌雲而自惜；鍾期既遇，奏流水以何慚？\n嗚呼！勝地不常，盛筵難再；蘭亭已矣，梓澤丘墟。臨別贈言，幸承恩於偉餞；登高作賦，是所望於群公。敢竭鄙懷，恭疏短引；一言均賦，四韻俱成。請灑潘江，各傾陸海雲爾。',
  },

  {
    id: 'classic-jishierlangwen',
    category: 'classic',
    dynasty: 'tang',
    title: '祭十二郎文',
    source: '韓愈',
    description: '韓愈悼念姪兒十二郎之祭文，聲淚俱下，為千古祭文第一。',
    content: '年月日，季父愈聞汝喪之七日，乃能銜哀致誠，使建中遠具時羞之奠，告汝十二郎之靈：\n嗚呼！吾少孤，及長，不省所怙，惟兄嫂是依。中年兄歿南方，吾與汝俱幼，從嫂歸葬河陽。既又與汝就食江南，零丁孤苦，未嘗一日相離也。吾上有三兄，皆不幸早世。承先人後者，在孫惟汝，在子惟吾。兩世一身，形單影隻。嫂嘗撫汝指吾而言曰：「韓氏兩世，惟此而已！」汝時猶小，當不復記憶；吾時雖能記憶，亦未知其言之悲也。\n吾年十九，始來京城。其後四年，而歸視汝。又四年，吾往河陽省墳墓，遇汝從嫂喪來葬。又二年，吾佐董丞相於汴州，汝來省吾，止一歲，請歸取其孥。明年，丞相薨，吾去汴州，汝不果來。是年，吾佐戎徐州，使取汝者始行，吾又罷去，汝又不果來。吾念汝從於東，東亦客也，不可以久；圖久遠者，莫如西歸，將成家而致汝。嗚呼！孰謂汝遽去吾而歿乎！吾與汝俱少年，以為雖暫相別，終當久相與處，故捨汝而旅食京師，以求斗斛之祿。誠知其如此，雖萬乘之公相，吾不以一日輟汝而就也！\n去年孟東野往，吾書與汝曰：「吾年未四十，而視茫茫，而髮蒼蒼，而齒牙動搖。念諸父與諸兄，皆康彊而早世，如吾之衰者，其能久存乎？吾不可去，汝不肯來，恐旦暮死，而汝抱無涯之戚也。」孰謂少者歿而長者存，彊者夭而病者全乎！\n嗚呼！其信然邪？其夢邪？其傳之非其真邪？信也，吾兄之盛德而夭其嗣乎？汝之純明而不克蒙其澤乎？少者彊者而夭歿，長者衰者而存全乎？未可以為信也。夢也，傳之非其真也，東野之書，耿蘭之報，何為而在吾側也？嗚呼！其信然矣！吾兄之盛德而夭其嗣矣！汝之純明宜業其家者，而不克蒙其澤矣！所謂天者誠難測，而神者誠難明矣！所謂理者不可推，而壽者不可知矣！\n雖然，吾自今年來，蒼蒼者或化而為白矣，動搖者或脫而落矣，毛血日益衰，志氣日益微，幾何不從汝而死也！死而有知，其幾何離？其無知，悲不幾時，而不悲者無窮期矣！\n汝之子始十歲，吾之子始五歲，少而彊者不可保，如此孩提者，又可冀其成立邪？嗚呼哀哉！嗚呼哀哉！\n汝去年書云：「比得軟腳病，往往而劇。」吾曰：「是疾也，江南之人，常常有之。」未始以為憂也。嗚呼！其竟以此而殞其生乎？抑別有疾而至斯乎？\n汝之書，六月十七日也；東野云，汝歿以六月二日；耿蘭之報無月日。蓋東野之使者不知問家人以月日？如耿蘭之報，不知當言月日？東野與吾書，乃問使者，使者妄稱以應之乎？其然乎？其不然乎？\n今吾使建中祭汝，弔汝之孤與汝之乳母。彼有食可守，以待終喪，則待終喪而取以來；如不能守以終喪，則遂取以來。其餘奴婢，並令守汝喪。吾力能改葬，終葬汝於先人之兆，然後惟其所願。\n嗚呼！汝病吾不知時，汝歿吾不知日，生不能相養以共居，歿不能撫汝以盡哀，斂不憑其棺，窆不臨其穴。吾行負神明，而使汝夭；不孝不慈，而不得與汝相養以生，相守以死。一在天之涯，一在地之角，生而影不與吾形相依，死而魂不與吾夢相接，吾實為之，其又何尤！彼蒼者天，曷其有極！\n自今已往，吾其無意於人世矣！當求數頃之田於伊潁之上，以待餘年。教吾子與汝子，幸其成；長吾女與汝女，待其嫁，如此而已。\n嗚呼！言有窮而情不可終，汝其知也邪？其不知也邪？嗚呼哀哉！尚饗。',
  },

  {
    id: 'poem-qingming',
    category: 'poem',
    dynasty: 'tang',
    title: '清明',
    source: '杜牧',
    description: '清明時節的經典絕句，寫行旅之人的愁緒。',
    content: '清明時節雨紛紛，路上行人欲斷魂。借問酒家何處有，牧童遙指杏花村。',
  },

  {
    id: 'poem-shanxing',
    category: 'poem',
    dynasty: 'tang',
    title: '山行',
    source: '杜牧',
    description: '深秋山行所見，楓葉紅於二月花。',
    content: '遠上寒山石徑斜，白雲生處有人家。停車坐愛楓林晚，霜葉紅於二月花。',
  },

  {
    id: 'poem-jinse',
    category: 'poem',
    dynasty: 'tang',
    title: '錦瑟',
    source: '李商隱',
    description: '李商隱最難索解的朦朧詩，錦瑟無端，深情綿邈。',
    content: '錦瑟無端五十弦，一弦一柱思華年。莊生曉夢迷蝴蝶，望帝春心託杜鵑。滄海月明珠有淚，藍田日暖玉生煙。此情可待成追憶，只是當時已惘然。',
  },

  {
    id: 'poem-changhenge',
    category: 'poem',
    dynasty: 'tang',
    title: '長恨歌',
    source: '白居易',
    description: '白居易敘述唐玄宗與楊貴妃愛情悲劇的長篇敘事詩，詞采華美，千古絕唱。',
    content: '漢皇重色思傾國，御宇多年求不得。楊家有女初長成，養在深閨人未識。\n天生麗質難自棄，一朝選在君王側。回眸一笑百媚生，六宮粉黛無顏色。\n春寒賜浴華清池，溫泉水滑洗凝脂。侍兒扶起嬌無力，始是新承恩澤時。\n雲鬢花顏金步搖，芙蓉帳暖度春宵。春宵苦短日高起，從此君王不早朝。\n承歡侍宴無閒暇，春從春遊夜專夜。後宮佳麗三千人，三千寵愛在一身。\n金屋妝成嬌侍夜，玉樓宴罷醉和春。姊妹弟兄皆列土，可憐光彩生門戶。\n遂令天下父母心，不重生男重生女。\n驪宮高處入青雲，仙樂風飄處處聞。緩歌慢舞凝絲竹，盡日君王看不足。\n漁陽鼙鼓動地來，驚破霓裳羽衣曲。九重城闕煙塵生，千乘萬騎西南行。\n翠華搖搖行復止，西出都門百餘里。六軍不發無奈何，宛轉蛾眉馬前死。\n花鈿委地無人收，翠翹金雀玉搔頭。君王掩面救不得，回看血淚相和流。\n黃埃散漫風蕭索，雲棧縈紆登劍閣。峨嵋山下少人行，旌旗無光日色薄。\n蜀江水碧蜀山青，聖主朝朝暮暮情。行宮見月傷心色，夜雨聞鈴腸斷聲。\n天旋日轉迴龍馭，到此躊躇不能去。馬嵬坡下泥土中，不見玉顏空死處。\n君臣相顧盡霑衣，東望都門信馬歸。歸來池苑皆依舊，太液芙蓉未央柳。\n芙蓉如面柳如眉，對此如何不淚垂？春風桃李花開日，秋雨梧桐葉落時。\n西宮南內多秋草，落葉滿階紅不掃。梨園弟子白髮新，椒房阿監青娥老。\n夕殿螢飛思悄然，孤燈挑盡未成眠。遲遲鐘鼓初長夜，耿耿星河欲曙天。\n鴛鴦瓦冷霜華重，翡翠衾寒誰與共？悠悠生死別經年，魂魄不曾來入夢。\n臨邛道士鴻都客，能以精誠致魂魄。為感君王輾轉思，遂教方士殷勤覓。\n排空馭氣奔如電，升天入地求之遍。上窮碧落下黃泉，兩處茫茫皆不見。\n忽聞海上有仙山，山在虛無縹緲間。樓閣玲瓏五雲起，其中綽約多仙子。\n中有一人字太真，雪膚花貌參差是。金闕西廂叩玉扃，轉教小玉報雙成。\n聞道漢家天子使，九華帳裡夢魂驚。攬衣推枕起徘徊，珠箔銀屏迤邐開。\n雲鬢半偏新睡覺，花冠不整下堂來。風吹仙袂飄飄舉，猶似霓裳羽衣舞。\n玉容寂寞淚闌干，梨花一枝春帶雨。\n含情凝睇謝君王，一別音容兩渺茫。昭陽殿裡恩愛絕，蓬萊宮中日月長。\n回頭下望人寰處，不見長安見塵霧。惟將舊物表深情，鈿合金釵寄將去。\n釵留一股合一扇，釵擘黃金合分鈿。但教心似金鈿堅，天上人間會相見。\n臨別殷勤重寄詞，詞中有誓兩心知。七月七日長生殿，夜半無人私語時。\n在天願作比翼鳥，在地願為連理枝。天長地久有時盡，此恨綿綿無絕期。',
  },

  {
    id: 'poem-pipaxing',
    category: 'poem',
    dynasty: 'tang',
    title: '琵琶行',
    source: '白居易',
    description: '白居易貶謫江州時所作，以琵琶女身世寄託天涯淪落之悲，敘事抒情俱臻化境。',
    content: '潯陽江頭夜送客，楓葉荻花秋瑟瑟。主人下馬客在船，舉酒欲飲無管弦。\n醉不成歡慘將別，別時茫茫江浸月。忽聞水上琵琶聲，主人忘歸客不發。\n尋聲暗問彈者誰，琵琶聲停欲語遲。移船相近邀相見，添酒回燈重開宴。\n千呼萬喚始出來，猶抱琵琶半遮面。轉軸撥弦三兩聲，未成曲調先有情。\n弦弦掩抑聲聲思，似訴平生不得志。低眉信手續續彈，說盡心中無限事。\n輕攏慢捻抹復挑，初為霓裳後六么。大弦嘈嘈如急雨，小弦切切如私語。\n嘈嘈切切錯雜彈，大珠小珠落玉盤。間關鶯語花底滑，幽咽泉流冰下難。\n冰泉冷澀弦凝絕，凝絕不通聲暫歇。別有幽愁暗恨生，此時無聲勝有聲。\n銀瓶乍破水漿迸，鐵騎突出刀槍鳴。曲終收撥當心畫，四弦一聲如裂帛。\n東船西舫悄無言，唯見江心秋月白。\n沉吟放撥插弦中，整頓衣裳起斂容。自言本是京城女，家在蝦蟆陵下住。\n十三學得琵琶成，名屬教坊第一部。曲罷曾教善才服，妝成每被秋娘妒。\n五陵年少爭纏頭，一曲紅綃不知數。鈿頭雲篦擊節碎，血色羅裙翻酒污。\n今年歡笑復明年，秋月春風等閒度。弟走從軍阿姨死，暮去朝來顏色故。\n門前冷落車馬稀，老大嫁作商人婦。商人重利輕別離，前月浮梁買茶去。\n去來江口守空船，繞船月明江水寒。夜深忽夢少年事，夢啼妝淚紅闌干。\n我聞琵琶已歎息，又聞此語重唧唧。同是天涯淪落人，相逢何必曾相識！\n我從去年辭帝京，謫居臥病潯陽城。潯陽地僻無音樂，終歲不聞絲竹聲。\n住近湓江地低濕，黃蘆苦竹繞宅生。其間旦暮聞何物？杜鵑啼血猿哀鳴。\n春江花朝秋月夜，往往取酒還獨傾。豈無山歌與村笛？嘔啞嘲哳難為聽。\n今夜聞君琵琶語，如聽仙樂耳暫明。莫辭更坐彈一曲，為君翻作琵琶行。\n感我此言良久立，卻坐促弦弦轉急。淒淒不似向前聲，滿座重聞皆掩泣。\n座中泣下誰最多？江州司馬青衫濕。',
  },

  {
    id: 'poem-chunjianghuayueye',
    category: 'poem',
    dynasty: 'tang',
    title: '春江花月夜',
    source: '張若虛',
    description: '張若虛「孤篇壓全唐」，以春江月夜為背景，探索宇宙與人生哲理，意境空靈深遠。',
    content: '春江潮水連海平，海上明月共潮生。灩灩隨波千萬里，何處春江無月明。\n江流宛轉繞芳甸，月照花林皆似霰。空裡流霜不覺飛，汀上白沙看不見。\n江天一色無纖塵，皎皎空中孤月輪。江畔何人初見月？江月何年初照人？\n人生代代無窮已，江月年年望相似。不知江月待何人，但見長江送流水。\n白雲一片去悠悠，青楓浦上不勝愁。誰家今夜扁舟子？何處相思明月樓？\n可憐樓上月裴回，應照離人妝鏡臺。玉戶簾中卷不去，搗衣砧上拂還來。\n此時相望不相聞，願逐月華流照君。鴻雁長飛光不度，魚龍潛躍水成文。\n昨夜閒潭夢落花，可憐春半不還家。江水流春去欲盡，江潭落月復西斜。\n斜月沉沉藏海霧，碣石瀟湘無限路。不知乘月幾人歸，落月搖情滿江樹。',
  },

  {
    id: 'poem-shudaonan',
    category: 'poem',
    dynasty: 'tang',
    title: '蜀道難',
    source: '李白',
    description: '李白以奇崛想像描寫蜀道之艱險，氣勢磅礴，為七言歌行巔峰之作。',
    content: '噫吁嚱，危乎高哉！蜀道之難，難於上青天！蠶叢及魚鳧，開國何茫然！爾來四萬八千歲，不與秦塞通人煙。西當太白有鳥道，可以橫絕峨眉巔。地崩山摧壯士死，然後天梯石棧相鉤連。上有六龍回日之高標，下有衝波逆折之回川。黃鶴之飛尚不得過，猿猱欲度愁攀援。青泥何盤盤，百步九折縈巖巒。捫參歷井仰脅息，以手撫膺坐長嘆。問君西遊何時還？畏途巉巖不可攀。但見悲鳥號古木，雄飛雌從繞林間。又聞子規啼夜月，愁空山。蜀道之難，難於上青天，使人聽此凋朱顏！連峰去天不盈尺，枯松倒掛倚絕壁。飛湍瀑流爭喧豗，砯崖轉石萬壑雷。其險也如此，嗟爾遠道之人胡為乎來哉！劍閣崢嶸而崔嵬，一夫當關，萬夫莫開。所守或匪親，化為狼與豺。朝避猛虎，夕避長蛇。磨牙吮血，殺人如麻。錦城雖云樂，不如早還家。蜀道之難，難於上青天，側身西望長咨嗟！',
  },

  {
    id: 'poem-mengyoutianmu',
    category: 'poem',
    dynasty: 'tang',
    title: '夢遊天姥吟留別',
    source: '李白',
    description: '李白記夢遊天姥山，想像瑰麗，表達「安能摧眉折腰事權貴」之傲骨。',
    content: '海客談瀛洲，煙濤微茫信難求。越人語天姥，雲霞明滅或可睹。天姥連天向天橫，勢拔五嶽掩赤城。天台一萬八千丈，對此欲倒東南傾。我欲因之夢吳越，一夜飛度鏡湖月。湖月照我影，送我至剡溪。謝公宿處今尚在，淥水蕩漾清猿啼。腳著謝公屐，身登青雲梯。半壁見海日，空中聞天雞。千巖萬轉路不定，迷花倚石忽已暝。熊咆龍吟殷巖泉，慄深林兮驚層巔。雲青青兮欲雨，水澹澹兮生煙。列缺霹靂，丘巒崩摧。洞天石扉，訇然中開。青冥浩蕩不見底，日月照耀金銀臺。霓為衣兮風為馬，雲之君兮紛紛而來下。虎鼓瑟兮鸞回車，仙之人兮列如麻。忽魂悸以魄動，恍驚起而長嗟。惟覺時之枕席，失向來之煙霞。世間行樂亦如此，古來萬事東流水。別君去兮何時還？且放白鹿青崖間，須行即騎訪名山。安能摧眉折腰事權貴，使我不得開心顏！',
  },

  {
    id: 'poem-xuanzhou',
    category: 'poem',
    dynasty: 'tang',
    title: '宣州謝朓樓餞別校書叔雲',
    source: '李白',
    description: '李白餞別族叔李雲，感懷憂憤而豪放不羈，名句「抽刀斷水水更流」。',
    content: '棄我去者，昨日之日不可留；亂我心者，今日之日多煩憂。長風萬里送秋色，對此可以酣高樓。蓬萊文章建安骨，中間小謝又清發。俱懷逸興壯思飛，欲上青天覽明月。抽刀斷水水更流，舉杯消愁愁更愁。人生在世不稱意，明朝散髮弄扁舟。',
  },

  {
    id: 'poem-lushanyao',
    category: 'poem',
    dynasty: 'tang',
    title: '廬山謠寄盧侍御虛舟',
    source: '李白',
    description: '李白遊廬山所作，飄逸出塵，展現求仙訪道之超脫心境。',
    content: '我本楚狂人，鳳歌笑孔丘。手持綠玉杖，朝別黃鶴樓。五嶽尋仙不辭遠，一生好入名山遊。廬山秀出南斗傍，屏風九疊雲錦張。影落明湖青黛光，金闕前開二峰長，銀河倒掛三石梁。香爐瀑布遙相望，迴崖沓嶂凌蒼蒼。翠影紅霞映朝日，鳥飛不到吳天長。登高壯觀天地間，大江茫茫去不還。黃雲萬里動風色，白波九道流雪山。好為廬山謠，興因廬山發。閒窺石鏡清我心，謝公行處蒼苔沒。早服還丹無世情，琴心三疊道初成。遙見仙人彩雲裡，手把芙蓉朝玉京。先期汗漫九垓上，願接盧敖遊太清。',
  },

  {
    id: 'poem-xiangyangge',
    category: 'poem',
    dynasty: 'tang',
    title: '襄陽歌',
    source: '李白',
    description: '李白醉歌襄陽山水，豪放灑脫，醉態可掬。',
    content: '落日欲沒峴山西，倒著接蘺花下迷。襄陽小兒齊拍手，攔街爭唱白銅鞮。旁人借問笑何事，笑殺山公醉似泥。鸕鶿杓，鸚鵡杯。百年三萬六千日，一日須傾三百杯。遙看漢水鴨頭綠，恰似葡萄初醱醅。此江若變作春酒，壘麴便築糟丘臺。千金駿馬換小妾，笑坐雕鞍歌落梅。車旁側掛一壺酒，鳳笙龍管行相催。咸陽市中歎黃犬，何如月下傾金罍？君不見晉朝羊公一片石，龜頭剝落生莓苔。淚亦不能為之墮，心亦不能為之哀。清風明月不用一錢買，玉山自倒非人推。舒州杓，力士鐺，李白與爾同死生。襄王雲雨今安在？江水東流猿夜聲。',
  },

  {
    id: 'poem-jiangshangyin',
    category: 'poem',
    dynasty: 'tang',
    title: '江上吟',
    source: '李白',
    description: '李白江上泛舟之作，以楚王臺榭與詞賦功名對比，凸顯超然之樂。',
    content: '木蘭之枻沙棠舟，玉簫金管坐兩頭。美酒樽中置千斛，載妓隨波任去留。仙人有待乘黃鶴，海客無心隨白鷗。屈平詞賦懸日月，楚王臺榭空山丘。興酣落筆搖五嶽，詩成笑傲凌滄洲。功名富貴若長在，漢水亦應西北流。',
  },

  {
    id: 'poem-liangfuyin',
    category: 'poem',
    dynasty: 'tang',
    title: '梁甫吟',
    source: '李白',
    description: '李白借樂府古題抒發懷才不遇之憤，長篇歌行，慷慨悲壯。',
    content: '長嘯梁甫吟，何時見陽春？君不見，朝歌屠叟辭棘津，八十西來釣渭濱。寧羞白髮照清水，逢時吐氣思經綸。廣張三千六百釣，風期暗與文王親。大賢虎變愚不測，當年頗似尋常人。君不見，高陽酒徒起草中，長揖山東隆準公。入門不拜騁雄辯，兩女輟洗來趨風。東下齊城七十二，指揮楚漢如旋蓬。狂客落魄尚如此，何況壯士當群雄！我欲攀龍見明主，雷公砰訇震天鼓。帝傍投壺多玉女，三時大笑開電光，倏爍晦冥起風雨。閶闔九門不可通，以額扣關閽者怒。白日不照吾精誠，杞國無事憂天傾。猰貐磨牙競人肉，騶虞不折生草莖。手接飛猱搏彫虎，側足焦原未言苦。智者可卷愚者豪，世人見我輕鴻毛。力排南山三壯士，齊相殺之費二桃。吳楚弄兵無劇孟，亞夫咍爾為徒勞。梁甫吟，梁甫吟，聲正悲。張公兩龍劍，神物合有時。風雲感會起屠釣，大人𡵻屼當安之。',
  },

  {
    id: 'poem-bingchexing',
    category: 'poem',
    dynasty: 'tang',
    title: '兵車行',
    source: '杜甫',
    description: '杜甫反戰名篇，以徵人夫婦生離死別控訴窮兵黷武，為新樂府先聲。',
    content: '車轔轔，馬蕭蕭，行人弓箭各在腰。爺孃妻子走相送，塵埃不見咸陽橋。牽衣頓足攔道哭，哭聲直上干雲霄。道旁過者問行人，行人但云點行頻。或從十五北防河，便至四十西營田。去時里正與裹頭，歸來頭白還戍邊。邊庭流血成海水，武皇開邊意未已。君不聞，漢家山東二百州，千村萬落生荊杞。縱有健婦把鋤犁，禾生隴畝無東西。況復秦兵耐苦戰，被驅不異犬與雞。長者雖有問，役夫敢申恨？且如今年冬，未休關西卒。縣官急索租，租稅從何出？信知生男惡，反是生女好。生女猶得嫁比鄰，生男埋沒隨百草。君不見，青海頭，古來白骨無人收。新鬼煩冤舊鬼哭，天陰雨濕聲啾啾。',
  },

  {
    id: 'poem-lirenxing',
    category: 'poem',
    dynasty: 'tang',
    title: '麗人行',
    source: '杜甫',
    description: '杜甫以麗人遊春為題，諷刺楊氏兄妹之奢靡，細膩鋪陳中含諷諫。',
    content: '三月三日天氣新，長安水邊多麗人。態濃意遠淑且真，肌理細膩骨肉勻。繡羅衣裳照暮春，蹙金孔雀銀麒麟。頭上何所有？翠微盍葉垂鬢唇。背後何所見？珠壓腰衱穩稱身。就中雲幕椒房親，賜名大國虢與秦。紫駝之峰出翠釜，水精之盤行素鱗。犀箸厭飫久未下，鸞刀縷切空紛綸。黃門飛鞚不動塵，御廚絡繹送八珍。簫鼓哀吟感鬼神，賓從雜遝實要津。後來鞍馬何逡巡，當軒下馬入錦茵。楊花雪落覆白蘋，青鳥飛去銜紅巾。炙手可熱勢絕倫，慎莫近前丞相嗔。',
  },

  {
    id: 'poem-maowuqiufeng',
    category: 'poem',
    dynasty: 'tang',
    title: '茅屋為秋風所破歌',
    source: '杜甫',
    description: '杜甫避亂成都時所作，由自身屋破推及天下寒士，胸懷博大。',
    content: '八月秋高風怒號，卷我屋上三重茅。茅飛渡江灑江郊，高者掛罥長林梢，下者飄轉沉塘坳。南村群童欺我老無力，忍能對面為盜賊。公然抱茅入竹去，唇焦口燥呼不得，歸來倚杖自歎息。俄頃風定雲墨色，秋天漠漠向昏黑。布衾多年冷似鐵，嬌兒惡臥踏裡裂。床頭屋漏無乾處，雨腳如麻未斷絕。自經喪亂少睡眠，長夜沾濕何由徹！安得廣廈千萬間，大庇天下寒士俱歡顏，風雨不動安如山。嗚呼！何時眼前突兀見此屋，吾廬獨破受凍死亦足！',
  },

  {
    id: 'poem-danqingyin',
    category: 'poem',
    dynasty: 'tang',
    title: '丹青引贈曹將軍霸',
    source: '杜甫',
    description: '杜甫贈畫家曹霸之作，以畫馬喻人生際遇，感慨今昔盛衰。',
    content: '將軍魏武之子孫，於今為庶為清門。英雄割據雖已矣，文采風流今尚存。學書初學衛夫人，但恨無過王右軍。丹青不知老將至，富貴於我如浮雲。開元之中常引見，承恩數上南熏殿。凌煙功臣少顏色，將軍下筆開生面。良相頭上進賢冠，猛將腰間大羽箭。褒公鄂公毛髮動，英姿颯爽來酣戰。先帝御馬五花驄，畫工如山貌不同。是日牽來赤墀下，迥立閶闔生長風。詔謂將軍拂絹素，意匠慘澹經營中。斯須九重真龍出，一洗萬古凡馬空。玉花卻在御榻上，榻上庭前屹相向。至尊含笑催賜金，圉人太僕皆惆悵。弟子韓幹早入室，亦能畫馬窮殊相。幹惟畫肉不畫骨，忍使驊騮氣凋喪。將軍畫善蓋有神，必逢佳士亦寫真。即今飄泊干戈際，屢貌尋常行路人。途窮反遭俗眼白，世上未有如公貧。但看古來盛名下，終日坎壈纏其身。',
  },

  {
    id: 'poem-gongsunniang',
    category: 'poem',
    dynasty: 'tang',
    title: '觀公孫大娘弟子舞劍器行',
    source: '杜甫',
    description: '杜甫觀公孫大娘弟子舞劍器，追憶盛唐歌舞之盛，感慨世事變遷。',
    content: '昔有佳人公孫氏，一舞劍器動四方。觀者如山色沮喪，天地為之久低昂。㸌如羿射九日落，矯如群帝驂龍翔。來如雷霆收震怒，罷如江海凝清光。絳唇珠袖兩寂寞，晚有弟子傳芬芳。臨潁美人在白帝，妙舞此曲神揚揚。與余問答既有以，感時撫事增惋傷。先帝侍女八千人，公孫劍器初第一。五十年間似反掌，風塵澒洞昏王室。梨園弟子散如煙，女樂餘姿映寒日。金粟堆前木已拱，瞿唐石城草蕭瑟。玳筵急管曲復終，樂極哀來月東出。老夫不知其所往，足繭荒山轉愁疾。',
  },

  {
    id: 'poem-gubaixing',
    category: 'poem',
    dynasty: 'tang',
    title: '古柏行',
    source: '杜甫',
    description: '杜甫詠孔明廟前古柏，託物言志，以柏之高大堅貞喻武侯忠貞品格。',
    content: '孔明廟前有老柏，柯如青銅根如石。霜皮溜雨四十圍，黛色參天二千尺。君臣已與時際會，樹木猶為人愛惜。雲來氣接巫峽長，月出寒通雪山白。憶昨路繞錦亭東，先主武侯同閟宮。崔嵬枝幹郊原古，窈窕丹青戶牖空。落落盤踞雖得地，冥冥孤高多烈風。扶持自是神明力，正直原因造化功。大廈如傾要梁棟，萬牛回首丘山重。不露文章世已驚，未辭剪伐誰能送？苦心豈免容螻蟻，香葉終經宿鸞鳳。志士幽人莫怨嗟，古來材大難為用。',
  },

  {
    id: 'poem-yinzhongbaxian',
    category: 'poem',
    dynasty: 'tang',
    title: '飲中八仙歌',
    source: '杜甫',
    description: '杜甫以連寫手法勾勒賀知章等八位酒仙醉態，生動傳神。',
    content: '知章騎馬似乘船，眼花落井水底眠。汝陽三斗始朝天，道逢麴車口流涎，恨不移封向酒泉。左相日興費萬錢，飲如長鯨吸百川，銜杯樂聖稱避賢。宗之瀟灑美少年，舉觴白眼望青天，皎如玉樹臨風前。蘇晉長齋繡佛前，醉中往往愛逃禪。李白一斗詩百篇，長安市上酒家眠。天子呼來不上船，自稱臣是酒中仙。張旭三杯草聖傳，脫帽露頂王公前，揮毫落紙如雲煙。焦遂五斗方卓然，高談雄辨驚四筵。',
  },

  {
    id: 'poem-zuiyougu',
    category: 'poem',
    dynasty: 'tang',
    title: '醉時歌',
    source: '杜甫',
    description: '杜甫贈廣文館博士鄭虔，借醉抒寫懷才不遇之悲憤。',
    content: '諸公袞袞登臺省，廣文先生官獨冷。甲第紛紛厭粱肉，廣文先生飯不足。先生有道出羲皇，先生有才過屈宋。德尊一代常坎坷，名垂萬古知何用！杜陵野客人更嗤，被褐短窄鬢如絲。日糴太倉五升米，時赴鄭老同襟期。得錢即相覓，沽酒不復疑。忘形到爾汝，痛飲真吾師。清夜沈沈動春酌，燈前細雨簷花落。但覺高歌有鬼神，焉知餓死填溝壑？相如逸才親滌器，子雲識字終投閣。先生早賦歸去來，石田茅屋荒蒼苔。儒術於我何有哉，孔丘盜跖俱塵埃。不須聞此意慘愴，生前相遇且銜杯。',
  },

  {
    id: 'poem-baixuege',
    category: 'poem',
    dynasty: 'tang',
    title: '白雪歌送武判官歸京',
    source: '岑參',
    description: '岑參邊塞詩代表作，以「忽如一夜春風來，千樹萬樹梨花開」寫雪景奇觀。',
    content: '北風卷地白草折，胡天八月即飛雪。忽如一夜春風來，千樹萬樹梨花開。散入珠簾濕羅幕，狐裘不暖錦衾薄。將軍角弓不得控，都護鐵衣冷難著。瀚海闌干百丈冰，愁雲慘澹萬里凝。中軍置酒飲歸客，胡琴琵琶與羌笛。紛紛暮雪下轅門，風掣紅旗凍不翻。輪臺東門送君去，去時雪滿天山路。山迴路轉不見君，雪上空留馬行處。',
  },

  {
    id: 'poem-luntaige',
    category: 'poem',
    dynasty: 'tang',
    title: '輪臺歌奉送封大夫出師西征',
    source: '岑參',
    description: '岑參寫唐軍出征輪臺之壯烈場面，氣勢雄渾，慷慨激昂。',
    content: '輪臺城頭夜吹角，輪臺城北旄頭落。羽書昨夜過渠黎，單于已在金山西。戍樓西望煙塵黑，漢軍屯在輪臺北。上將擁旄西出征，平明吹笛大軍行。四邊伐鼓雪海湧，三軍大呼陰山動。虜塞兵氣連雲屯，戰場白骨纏草根。劍河風急雪片闊，沙口石凍馬蹄脫。亞相勤王甘苦辛，誓將報主靜邊塵。古來青史誰不見，今見功名勝古人。',
  },

  {
    id: 'poem-zoumahe',
    category: 'poem',
    dynasty: 'tang',
    title: '走馬川行奉送出師西征',
    source: '岑參',
    description: '岑參以走馬川之奇險襯托將士英勇，句句用韻，節奏急促如行軍。',
    content: '君不見走馬川行雪海邊，平沙莽莽黃入天。輪臺九月風夜吼，一川碎石大如斗，隨風滿地石亂走。匈奴草黃馬正肥，金山西見煙塵飛，漢家大將西出師。將軍金甲夜不脫，半夜軍行戈相撥，風頭如刀面如割。馬毛帶雪汗氣蒸，五花連錢旋作冰，幕中草檄硯水凝。虜騎聞之應膽懾，料知短兵不敢接，車師西門佇獻捷。',
  },

  {
    id: 'poem-yangexing',
    category: 'poem',
    dynasty: 'tang',
    title: '燕歌行',
    source: '高適',
    description: '高適邊塞詩壓卷之作，將士浴血與將軍享樂對比，沉鬱悲壯。',
    content: '漢家煙塵在東北，漢將辭家破殘賊。男兒本自重橫行，天子非常賜顏色。摐金伐鼓下榆關，旌旆逶迤碣石間。校尉羽書飛瀚海，單于獵火照狼山。山川蕭條極邊土，胡騎憑陵雜風雨。戰士軍前半死生，美人帳下猶歌舞。大漠窮秋塞草腓，孤城落日鬥兵稀。身當恩遇恆輕敵，力盡關山未解圍。鐵衣遠戍辛勤久，玉箸應啼別離後。少婦城南欲斷腸，徵人薊北空回首。邊庭飄颻那可度，絕域蒼茫更何有。殺氣三時作陣雲，寒聲一夜傳刁斗。相看白刃血紛紛，死節從來豈顧勳。君不見沙場征戰苦，至今猶憶李將軍。',
  },

  {
    id: 'poem-fengqiuzuo',
    category: 'poem',
    dynasty: 'tang',
    title: '封丘作',
    source: '高適',
    description: '高適任封丘尉時所作，寫縣吏之苦與歸隱之念，真摯動人。',
    content: '我本漁樵孟諸野，一生自是悠悠者。乍可狂歌草澤中，寧堪作吏風塵下？只言小邑無所為，公門百事皆有期。拜迎官長心欲碎，鞭撻黎庶令人悲。歸來向家問妻子，舉家盡笑今如此。生事應須南畝田，世情盡付東流水。夢想舊山安在哉，為銜君命且遲回。乃知梅福徒為爾，轉憶陶潛歸去來。',
  },

  {
    id: 'poem-taoyuanxing',
    category: 'poem',
    dynasty: 'tang',
    title: '桃源行',
    source: '王維',
    description: '王維以陶淵明桃花源記為本，寫成七言古詩，清麗如畫。',
    content: '漁舟逐水愛山春，兩岸桃花夾古津。坐看紅樹不知遠，行盡青溪不見人。山口潛行始隈隩，山開曠望旋平陸。遙看一處攢雲樹，近入千家散花竹。樵客初傳漢姓名，居人未改秦衣服。居人共住武陵源，還從物外起田園。月明松下房櫳靜，日出雲中雞犬喧。驚聞俗客爭來集，競引還家問都邑。平明閭巷掃花開，薄暮漁樵乘水入。初因避地去人間，及至成仙遂不還。峽裡誰知有人事，世中遙望空雲山。不疑靈境難聞見，塵心未盡思鄉縣。出洞無論隔山水，辭家終擬長遊衍。自謂經過舊不迷，安知峰壑今來變。當時只記入山深，青溪幾度到雲林。春來遍是桃花水，不辨仙源何處尋。',
  },

  {
    id: 'poem-luoyangnv',
    category: 'poem',
    dynasty: 'tang',
    title: '洛陽女兒行',
    source: '王維',
    description: '王維以洛陽貴女之奢華對比貧女浣紗，諷刺世態炎涼。',
    content: '洛陽女兒對門居，才可顏容十五餘。良人玉勒乘驄馬，侍女金盤膾鯉魚。畫閣朱樓盡相望，紅桃綠柳垂簷向。羅帷送上七香車，寶扇迎歸九華帳。狂夫富貴在青春，意氣驕奢劇季倫。自憐碧玉親教舞，不惜珊瑚持與人。春窗曙滅九微火，九微片片飛花瑣。戲罷曾無理曲時，妝成祗是薰香坐。城中相識盡繁華，日夜經過趙李家。誰憐越女顏如玉，貧賤江頭自浣紗。',
  },

  {
    id: 'poem-laoyuanjie',
    category: 'poem',
    dynasty: 'tang',
    title: '老將行',
    source: '王維',
    description: '王維寫老將昔日征戰功勳與晚年冷落，寄託不平之氣。',
    content: '少年十五二十時，步行奪得胡馬騎。射殺山中白額虎，肯數鄴下黃鬚兒。一身轉戰三千里，一劍曾當百萬師。漢兵奮迅如霹靂，虜騎奔騰畏蒺藜。衛青不敗由天幸，李廣無功緣數奇。自從棄置便衰朽，世事蹉跎成白首。昔時飛箭無全目，今日垂楊生左肘。路旁時賣故侯瓜，門前學種先生柳。蒼茫古木連窮巷，寥落寒山對虛牖。誓令疏勒出飛泉，不似潁川空使酒。賀蘭山下陣如雲，羽檄交馳日夕聞。節使三河募年少，詔書五道出將軍。試拂鐵衣如雪色，聊持寶劍動星文。願得燕弓射大將，恥令越甲鳴吳軍。莫嫌舊日雲中守，猶堪一戰取功勳。',
  },

  {
    id: 'poem-gucongjunxing',
    category: 'poem',
    dynasty: 'tang',
    title: '古從軍行',
    source: '李頎',
    description: '李頎借漢諷唐，寫征戰之慘烈與將士之苦，結句「空見蒲桃入漢家」尤為警策。',
    content: '白日登山望烽火，黃昏飲馬傍交河。行人刁斗風沙暗，公主琵琶幽怨多。野雲萬里無城郭，雨雪紛紛連大漠。胡雁哀鳴夜夜飛，胡兒眼淚雙雙落。聞道玉門猶被遮，應將性命逐輕車。年年戰骨埋荒外，空見蒲桃入漢家。',
  },

  {
    id: 'poem-songchenzhang',
    category: 'poem',
    dynasty: 'tang',
    title: '送陳章甫',
    source: '李頎',
    description: '李頎送別友人陳章甫，以四月南風起興，抒寫離情別緒與人生感慨。',
    content: '四月南風大麥黃，棗花未落桐葉長。青山朝別暮還見，嘶馬出門思故鄉。陳侯立身何坦蕩，虯鬚虎眉仍大顙。腹中貯書一萬卷，不肯低頭在草莽。東門酤酒飲我曹，心輕萬事如鴻毛。醉臥不知白日暮，有時空望孤雲高。長河浪頭連天黑，津口停舟渡不得。鄭國遊人未及家，洛陽行子空歎息。聞道故林相識多，罷官昨日今如何。',
  },

  {
    id: 'poem-bayueshiwuye',
    category: 'poem',
    dynasty: 'tang',
    title: '八月十五夜贈張功曹',
    source: '韓愈',
    description: '韓愈中秋夜贈友人，寫遷謫之苦與歸鄉之願，情感跌宕。',
    content: '纖雲四卷天無河，清風吹空月舒波。沙平水息聲影絕，一杯相屬君當歌。君歌聲酸辭且苦，不能聽終淚如雨。洞庭連天九疑高，蛟龍出沒猩鼯號。十生九死到官所，幽居默默如藏逃。下床畏蛇食畏藥，海氣濕蟄熏腥臊。昨者州前槌大鼓，嗣皇繼聖登夔皋。赦書一日行萬里，罪從大辟皆除死。遷者追回流者還，滌瑕蕩垢清朝班。州家申名使家抑，坎軻只得移荊蠻。判司卑官不堪說，未免捶楚塵埃間。同時輩流多上道，天路幽險難追攀。君歌且休聽我歌，我歌今與君殊科。一年明月今宵多，人生由命非由他，有酒不飲奈明何。',
  },

  {
    id: 'poem-shiguge',
    category: 'poem',
    dynasty: 'tang',
    title: '石鼓歌',
    source: '韓愈',
    description: '韓愈詠周宣王石鼓，以詩為石鼓奔走吶喊，氣勢宏肆，為七古之鴻篇。',
    content: '張生手持石鼓文，勸我試作石鼓歌。少陵無人謫仙死，才薄將奈石鼓何。周綱凌遲四海沸，宣王憤起揮天戈。大開明堂受朝賀，諸侯劍佩鳴相磨。蒐于岐陽騁雄俊，萬里禽獸皆遮羅。鐫功勒成告萬世，鑿石作鼓隳嵯峨。從臣才藝咸第一，揀選撰刻留山阿。雨淋日炙野火燎，鬼物守護煩撝呵。公從何處得紙本？毫髮盡備無差訛。辭嚴義密讀難曉，字體不類隸與蝌。年深豈免有缺畫，快劍斫斷生蛟鼉。鸞翔鳳翥眾仙下，珊瑚碧樹交枝柯。金繩鐵索鎖紐壯，古鼎躍水龍騰梭。陋儒編詩不收入，二雅褊迫無委蛇。孔子西行不到秦，掎摭星宿遺羲娥。嗟余好古生苦晚，對此涕淚雙滂沱。憶昔初蒙博士徵，其年始改稱元和。故人從軍在右輔，為我度量掘臼科。濯冠沐浴告祭酒，如此至寶存豈多。氈包席裹可立致，十鼓祇載數駱駝。薦諸太廟比郜鼎，光價豈止百倍過。聖恩若許留太學，諸生講解得切磋。觀經鴻都尚填咽，坐見舉國來奔波。剜苔剔蘚露節角，安置妥帖平不頗。大廈深簷與蓋覆，經歷久遠期無佗。中朝大官老於事，詎肯感激徒媕娿。牧童敲火牛礪角，誰復著手為摩挲。日銷月鑠就埋沒，六年西顧空吟哦。羲之俗書趁姿媚，數紙尚可博白鵝。繼周八代爭戰罷，無人收拾理則那。方今太平日無事，柄任儒術崇丘軻。安能以此上論列，願借辯口如懸河。石鼓之歌止於此，嗚呼吾意其蹉跎。',
  },

  {
    id: 'poem-yanmen',
    category: 'poem',
    dynasty: 'tang',
    title: '雁門太守行',
    source: '李賀',
    description: '李賀以濃豔詞采寫邊城將士誓死報國之志，意象奇詭。',
    content: '黑雲壓城城欲摧，甲光向日金鱗開。角聲滿天秋色裡，塞上燕脂凝夜紫。半卷紅旗臨易水，霜重鼓寒聲不起。報君黃金臺上意，提攜玉龍為君死。',
  },

  {
    id: 'poem-jintongxianren',
    category: 'poem',
    dynasty: 'tang',
    title: '金銅仙人辭漢歌',
    source: '李賀',
    description: '李賀借漢銅人遷徙之史事，抒發亡國之痛與盛衰之嘆。',
    content: '茂陵劉郎秋風客，夜聞馬嘶曉無跡。畫欄桂樹懸秋香，三十六宮土花碧。魏官牽車指千里，東關酸風射眸子。空將漢月出宮門，憶君清淚如鉛水。衰蘭送客咸陽道，天若有情天亦老。攜盤獨出月荒涼，渭城已遠波聲小。',
  },

  {
    id: 'poem-lipingkonghou',
    category: 'poem',
    dynasty: 'tang',
    title: '李憑箜篌引',
    source: '李賀',
    description: '李賀以奇詭想像描寫樂師李憑彈奏箜篌之絕妙，鬼神為之動容。',
    content: '吳絲蜀桐張高秋，空白凝雲頹不流。江娥啼竹素女愁，李憑中國彈箜篌。崑山玉碎鳳凰叫，芙蓉泣露香蘭笑。十二門前融冷光，二十三絲動紫皇。女媧煉石補天處，石破天驚逗秋雨。夢入神山教神嫗，老魚跳波瘦蛟舞。吳質不眠倚桂樹，露腳斜飛濕寒兔。',
  },

  {
    id: 'poem-qinfuyin',
    category: 'poem',
    dynasty: 'tang',
    title: '秦婦吟',
    source: '韋莊',
    description: '韋莊借秦婦之口敘黃巢之亂全過程，為唐代最長敘事詩，與長恨歌並稱雙璧。',
    content: '中和癸卯春三月，洛陽城外花如雪。東西南北路人絕，綠楊悄悄香塵滅。路旁忽見如花人，獨向綠楊陰下歇。鳳側鸞欹鬢腳斜，紅攢黛斂眉心折。借問女郎何處來？含顰欲語聲先咽。回頭斂袂謝行人，喪亂漂淪何堪說！三年陷賊留秦地，依稀記得秦中事。君能為妾解金鞍，妾亦與君停玉趾。前年庚子臘月五，正閉金籠教鸚鵡。斜開鸞鏡懶梳頭，閒憑雕欄慵不語。忽看門外起紅塵，已見街中擂金鼓。居人走出半倉皇，朝士歸來尚疑誤。是時西面官軍入，擬向潼關為警急。皆言博野自相持，盡道賊軍來未及。須臾主父乘奔至，下馬入門癡似醉。適逢紫蓋去蒙塵，已見白旗來匝地。扶羸攜幼競相呼，上屋緣牆不知次。南鄰走入北鄰藏，東鄰走向西鄰避。北鄰諸婦咸相湊，戶外崩騰如走獸。轟轟崑崙乾坤動，萬馬雷聲從地湧。火迸金星上九天，十二官街煙烘烔。日輪西下寒光白，上帝無言空脈脈。陰雲暈氣若重圍，宦者流星如血色。紫氣漸隨帝座移，妖光暗射臺星坼。家家流血如泉沸，處處冤聲聲動地。舞伎歌姬盡暗捐，嬰兒稚女皆生棄。東鄰有女眉新畫，傾國傾城不知價。長戈擁得上戎車，回首香閨淚盈把。旋抽金線學縫旗，纔上雕鞍教走馬。從來不是此流人，莫管街頭急迎者。西鄰有女真仙子，一寸橫波剪秋水。妝成只對鏡中春，年幼不知門外事。一夫跳躍上金階，斜袒半肩欲相恥。牽衣不肯出朱門，紅粉香脂刀下死。南鄰有女不記姓，昨日良媒新納聘。琉璃階上不聞行，翡翠簾間空見影。忽看庭際刀刃鳴，身首支離在俄頃。仰天掩面哭一聲，女弟女兄同入井。北鄰少婦行相促，旋解雲鬟拭眉綠。已聞擊托壞高門，不覺攀緣上重屋。須臾四面火光來，欲下危梯梯又摧。煙中大叫猶求救，樑上懸屍已作灰。妾身幸得全刀鋸，不敢踟躕久回顧。旋梳蟬鬢逐軍行，強展蛾眉出門去。舊里從茲不得歸，六親自此無尋處。一從陷賊經三載，終日驚憂心膽碎。夜臥千重劍戟圍，朝餐一味人肝膾。鴛幃縱入豈成歡，寶貨雖多非所愛。蓬頭面垢眉猶赤，幾轉橫波看不得。衣裳顛倒語言異，面上誇功雕作字。柏臺多士盡狐精，蘭省諸郎皆鼠魅。還將短髮戴華簪，不脫朝衣纏繡被。翻持象笏作三公，倒佩金魚為兩史。朝聞奏對入朝堂，暮見喧呼來酒市。一朝五鼓人驚起，叫嘯喧爭如竊語。夜來探馬入皇城，昨日官軍收赤水。赤水去城一百里，朝若來兮暮應至。凶徒馬上暗吞聲，女伴閨中潛生喜。皆言冤憤此時銷，必謂妖徒今日死。逡巡走馬傳聲急，又道官軍全陣入。大彭小彭相顧憂，二郎四郎抱鞍泣。沉沉數日無消息，必謂軍前已銜璧。簸旗掉劍卻來歸，又道官軍悉敗績。四面從茲多厄束，一斗黃金一斗粟。尚讓廚中食木皮，黃巢機上刲人肉。東南斷絕無糧道，溝壑漸平人漸少。六軍門外倚殭屍，七架營中填餓殍。長安寂寂今何有？廢市荒街麥苗秀。採樵斫盡杏園花，修寨誅殘御溝柳。華軒繡轂皆銷散，甲第朱門無一半。含元殿上狐兔行，花萼樓前荊棘滿。昔時繁盛皆埋沒，舉目淒涼無故物。內庫燒為錦繡灰，天街踏盡公卿骨。來時曉出城東陌，城外風煙如塞色。路旁時見游奕軍，坡下寂無迎送客。霸陵東望人煙絕，樹鎖驪山金翠滅。大道俱成棘子林，行人夜宿長安月。明朝曉至三峰路，百萬人家無一戶。破落田園但有蒿，摧殘竹樹皆無主。路旁試問金天神，金天無語愁於人。廟前古柏有殘枿，殿上金爐生暗塵。一從狂寇陷中國，天地晦冥風雨黑。案前神水咒不成，壁上陰兵驅不得。閒日徒歆奠饗恩，危時不助神通力。我今愧恧拙為神，且向山中深避匿。寰中簫管不曾聞，筵上犧牲無處覓。旋教魘鬼傍鄉村，誅剝生靈過朝夕。妾聞此語愁更愁，天遣時災非自由。神在山中猶避難，何須責望東諸侯。前年又出揚震關，舉頭雲際見荊山。如從地府到人間，頓覺時清天地閒。陝州主帥忠且貞，不動干戈唯守城。蒲州主帥能戢兵，千里晏然無戈聲。朝攜寶貨無人間，暮插金釵唯獨行。明朝又過新安東，路上乞漿逢一翁。蒼蒼面帶苔蘚色，隱隱身藏蓬荻中。問翁本是何鄉曲？底事寒天霜露宿？老翁蹔起欲陳辭，卻坐支頤仰天哭。鄉園本貫東畿縣，歲歲耕桑臨御苑。十幅紅旗一丈竿，叮嚀話向人間看。岳瀆不動氣沉沉，一點春煙入寥廓。少年無賴不足數，老去那能免羈旅。君不見，男兒丈夫志氣揚，安能對鏡空悲傷。明朝且向江頭別，日暮相思隔雲月。',
  },

  {
    id: 'poem-daibeibaitou',
    category: 'poem',
    dynasty: 'tang',
    title: '代悲白頭翁',
    source: '劉希夷',
    description: '劉希夷感嘆人生無常、紅顏易老之名篇，「年年歲歲花相似，歲歲年年人不同」千古傳誦。',
    content: '洛陽城東桃李花，飛來飛去落誰家。洛陽女兒惜顏色，坐見落花長歎息。今年花落顏色改，明年花開復誰在。已見松柏摧為薪，更聞桑田變成海。古人無復洛城東，今人還對落花風。年年歲歲花相似，歲歲年年人不同。寄言全盛紅顏子，應憐半死白頭翁。此翁白頭真可憐，伊昔紅顏美少年。公子王孫芳樹下，清歌妙舞落花前。光祿池臺開錦繡，將軍樓閣畫神仙。一朝臥病無相識，三春行樂在誰邊。婉轉蛾眉能幾時，須臾鶴髮亂如絲。但看古來歌舞地，惟有黃昏鳥雀悲。',
  },

  {
    id: 'poem-chiyunge',
    category: 'poem',
    dynasty: 'tang',
    title: '長相思',
    source: '李白',
    description: '李白以長相思為題，寫男女相思之苦，深情綿邈，一唱三歎。',
    content: '長相思，在長安。絡緯秋啼金井闌，微霜淒淒簟色寒。孤燈不明思欲絕，卷帷望月空長歎。美人如花隔雲端。上有青冥之高天，下有淥水之波瀾。天長路遠魂飛苦，夢魂不到關山難。長相思，摧心肝。',
  },

  {
    id: 'poem-wuyiqiao',
    category: 'poem',
    dynasty: 'tang',
    title: '烏棲曲',
    source: '李白',
    description: '李白擬樂府舊題，寫吳王宮中夜宴之奢靡，以烏棲歸去暗寓諷諫。',
    content: '姑蘇臺上烏棲時，吳王宮裡醉西施。吳歌楚舞歡未畢，青山欲銜半邊日。銀箭金壺漏水多，起看秋月墜江波。東方漸高奈樂何。',
  },

  {
    id: 'poem-yanzhige',
    category: 'poem',
    dynasty: 'tang',
    title: '燕支行',
    source: '王維',
    description: '王維寫將軍出征大獲全勝，氣勢雄壯，為早期邊塞詩佳作。',
    content: '漢家天將才且雄，來時謁帝明光宮。萬乘親推雙闕下，千官出餞五陵東。誓辭甲第金門裡，身作長城玉塞中。衛霍才堪一騎將，朝廷不數貳師功。趙魏燕韓多勁卒，關西俠少何咆勃。報讎只是聞嘗膽，飲酒不曾妨刮骨。畫戟雕戈白日寒，連旗大旆黃塵沒。疊鼓遙翻瀚海波，鳴笳亂動天山月。麒麟錦帶佩吳鉤，颯沓青驪躍紫騮。拔劍已斷天驕臂，歸鞍共飲月支頭。漢兵大呼一當百，虜騎相看哭且愁。教戰雖令赴湯火，終知上將先伐謀。',
  },

  {
    id: 'poem-longtouyin',
    category: 'poem',
    dynasty: 'tang',
    title: '隴頭吟',
    source: '王維',
    description: '王維寫關中少年戍邊老去，以長安少年與關西老將對比，悲涼感慨。',
    content: '長安少年遊俠客，夜上戍樓看太白。隴頭明月迥臨關，隴上行人夜吹笛。關西老將不勝愁，駐馬聽之雙淚流。身經大小百餘戰，麾下偏裨萬戶侯。蘇武才為典屬國，節旄落盡海西頭。',
  },

  {
    id: 'poem-duanqueliangbi',
    category: 'poem',
    dynasty: 'tang',
    title: '短歌行（贈王郎）',
    source: '杜甫',
    description: '杜甫短歌行，以王郎才華橫溢卻不得志為題，勸其及時努力。',
    content: '王郎酒酣拔劍斫地歌莫哀，我能拔爾抑塞磊落之奇才。豫章翻風白日動，鯨魚跋浪滄溟開。且脫佩劍休裴回。西得諸侯棹錦水，欲向何門趿珠履？仲宣樓頭春色深，青眼高歌望吾子。眼中之人吾老矣。',
  },

  {
    id: 'poem-fudeguyuan',
    category: 'poem',
    dynasty: 'tang',
    title: '賦得古原草送別',
    source: '白居易',
    description: '白居易少年成名之作，以原上草喻離情，生命力與別意交織。',
    content: '離離原上草，一歲一枯榮。野火燒不盡，春風吹又生。遠芳侵古道，晴翠接荒城。又送王孫去，萋萋滿別情。',
  },

  {
    id: 'poem-maitangweng',
    category: 'poem',
    dynasty: 'tang',
    title: '賣炭翁',
    source: '白居易',
    description: '白居易新樂府代表作，揭露宮市之弊，描寫老翁辛酸。',
    content: '賣炭翁，伐薪燒炭南山中。滿面塵灰煙火色，兩鬢蒼蒼十指黑。賣炭得錢何所營？身上衣裳口中食。可憐身上衣正單，心憂炭賤願天寒。夜來城外一尺雪，曉駕炭車輾冰轍。牛困人飢日已高，市南門外泥中歇。翩翩兩騎來是誰？黃衣使者白衫兒。手把文書口稱敕，迴車叱牛牽向北。一車炭，千餘斤，宮使驅將惜不得。半匹紅紗一丈綾，繫向牛頭充炭直。',
  },

  {
    id: 'poem-qiantangchunxing',
    category: 'poem',
    dynasty: 'tang',
    title: '錢塘湖春行',
    source: '白居易',
    description: '白居易任杭州刺史時所作，描寫西湖早春風光。',
    content: '孤山寺北賈亭西，水面初平雲腳低。幾處早鶯爭暖樹，誰家新燕啄春泥。亂花漸欲迷人眼，淺草才能沒馬蹄。最愛湖東行不足，綠楊陰裏白沙堤。',
  },

  {
    id: 'poem-yijiangnan',
    category: 'poem',
    dynasty: 'tang',
    title: '憶江南',
    source: '白居易',
    description: '白居易晚年回憶江南風物之作，簡潔明快，膾炙人口。',
    content: '江南好，風景舊曾諳。日出江花紅勝火，春來江水綠如藍。能不憶江南？',
  },

  {
    id: 'poem-chishang',
    category: 'poem',
    dynasty: 'tang',
    title: '池上',
    source: '白居易',
    description: '白居易寫小兒偷採白蓮的天真童趣，自然生動。',
    content: '小娃撐小艇，偷採白蓮回。不解藏蹤跡，浮萍一道開。',
  },

  {
    id: 'poem-yeyujibei',
    category: 'poem',
    dynasty: 'tang',
    title: '夜雨寄北',
    source: '李商隱',
    description: '李商隱羈旅巴蜀，雨夜思念妻子之作。',
    content: '君問歸期未有期，巴山夜雨漲秋池。何當共剪西窗燭，卻話巴山夜雨時。',
  },

  {
    id: 'poem-congjunxing',
    category: 'poem',
    dynasty: 'tang',
    title: '從軍行',
    source: '王昌齡',
    description: '王昌齡邊塞詩名篇，孤城萬里，壯心不已。',
    content: '青海長雲暗雪山，孤城遙望玉門關。黃沙百戰穿金甲，不破樓蘭終不還。',
  },

  {
    id: 'poem-jinshilu',
    category: 'poem',
    dynasty: 'tang',
    title: '金谷園',
    source: '杜牧',
    description: '杜牧憑吊金谷園，感嘆繁華如夢。',
    content: '繁華事散逐香塵，流水無情草自春。日暮東風怨啼鳥，落花猶似墮樓人。',
  },

  {
    id: 'poem-wuxu',
    category: 'poem',
    dynasty: 'tang',
    title: '赤壁',
    source: '杜牧',
    description: '杜牧以三國赤壁之戰，抒發歷史滄桑之嘆。',
    content: '折戟沉沙鐵未銷，自將磨洗認前朝。東風不與周郎便，銅雀春深鎖二喬。',
  },

  {
    id: 'poem-leiyu',
    category: 'poem',
    dynasty: 'tang',
    title: '暮秋獨遊曲江',
    source: '李商隱',
    description: '李商隱寫秋日曲江，荷枯人去，悵惘無邊。',
    content: '荷葉生時春恨生，荷葉枯時秋恨成。深知身在情長在，悵望江頭江水聲。',
  },

  {
    id: 'poem-tianxiaoyao',
    category: 'poem',
    dynasty: 'tang',
    title: '瑤池',
    source: '李商隱',
    description: '李商隱諷刺求仙之妄想。',
    content: '瑤池阿母綺窗開，黃竹歌聲動地哀。八駿日行三萬里，穆王何事不重來。',
  },

  {
    id: 'poem-langtao',
    category: 'poem',
    dynasty: 'tang',
    title: '浪淘沙·九曲黃河萬里沙',
    source: '劉禹錫',
    description: '劉禹錫借黃河喻歷史滄桑。',
    content: '九曲黃河萬里沙，浪淘風簸自天涯。如今直上銀河去，同到牽牛織女家。',
  },

  {
    id: 'poem-xishi',
    category: 'poem',
    dynasty: 'tang',
    title: '西塞山懷古',
    source: '劉禹錫',
    description: '劉禹錫懷古名篇，人世幾回傷往事。',
    content: '王濬樓船下益州，金陵王氣黯然收。千尋鐵鎖沉江底，一片降幡出石頭。人世幾回傷往事，山形依舊枕寒流。今逢四海為家日，故壘蕭蕭蘆荻秋。',
  },

  {
    id: 'poem-shanzhongji',
    category: 'poem',
    dynasty: 'tang',
    title: '山中送別',
    source: '王維',
    description: '王維送別詩，清新自然。',
    content: '山中相送罷，日暮掩柴扉。春草年年綠，王孫歸不歸。',
  },

  {
    id: 'poem-dujincun',
    category: 'poem',
    dynasty: 'tang',
    title: '渡荊門送別',
    source: '李白',
    description: '李白出蜀之作，意境開闘，情景交融。',
    content: '渡遠荊門外，來從楚國遊。山隨平野盡，江入大荒流。月下飛天鏡，雲生結海樓。仍憐故鄉水，萬里送行舟。',
  },

  {
    id: 'poem-choutian',
    category: 'poem',
    dynasty: 'tang',
    title: '酬樂天初逢席上見贈',
    source: '劉禹錫',
    description: '劉禹錫達觀之作，沉舟側畔千帆過。',
    content: '巴山楚水淒涼地，二十三年棄置身。懷舊空吟聞笛賦，到鄉翻似爛柯人。沉舟側畔千帆過，病樹前頭萬木春。今日聽君歌一曲，暫憑杯酒長精神。',
  },

  {
    id: 'poem-dengcezhuhou',
    category: 'poem',
    dynasty: 'tang',
    title: '登科後',
    source: '孟郊',
    description: '孟郊及第之喜，春風得意馬蹄疾。',
    content: '昔日齷齪不足誇，今朝放蕩思無涯。春風得意馬蹄疾，一日看盡長安花。',
  },

  {
    id: 'poem-youzibuqu',
    category: 'poem',
    dynasty: 'tang',
    title: '遊子吟',
    source: '孟郊',
    description: '孟郊慈母情，深沉感人，傳誦千年。',
    content: '慈母手中線，遊子身上衣。臨行密密縫，意恐遲遲歸。誰言寸草心，報得三春暉。',
  },

  {
    id: 'poem-tingtao',
    category: 'poem',
    dynasty: 'tang',
    title: '聽箏',
    source: '李端',
    description: '李端以箏聲寫離愁，構思巧妙。',
    content: '鳴箏金粟柱，素手玉房前。欲得周郎顧，時時誤拂弦。',
  },

  {
    id: 'poem-xinyue',
    category: 'poem',
    dynasty: 'tang',
    title: '新嫁娘詞',
    source: '王建',
    description: '王建寫新嫁娘的謹慎與可愛。',
    content: '三日入廚下，洗手作羹湯。未諳姑食性，先遣小姑嘗。',
  },

  {
    id: 'classic-yuanqijiu',
    category: 'classic',
    dynasty: 'tang',
    title: '原毀（全文）',
    source: '韓愈',
    description: '韓愈論毀謗之由，揭示君子小人之別。',
    content: '古之君子，其責己也重以周，其待人也輕以約。重以周，故不怠；輕以約，故人樂為善。聞古之君子，其責己也重以周，其待人也輕以約。重以周，故不怠；輕以約，故人樂為善。今之君子則不然。其責人也詳，其待己也廉。詳，故人難於為善；廉，故己不自知其過。且夫己之不能為，而欲人之能為；己之不能知，而欲人之能知。是以毀謗之言起，而人情日以薄。夫毀人之善，非徒毀之也，實欲掩己之不善也；嫉人之能，非徒嫉之也，實欲掩己之不能也。古之君子，見人之一善，則欣然稱之，見人之一能，則力薦之，不以己之不能而嫉人，不以己之不知而毀人。故人皆樂為君子，而風俗淳厚。今之君子，己無善而毀人之善，己無能而嫉人之能，是以小人日多，而君子日少。此風不可不革，此源不可不原也。',
  },

  {
    id: 'classic-jiantaishixingshu',
    category: 'classic',
    dynasty: 'tang',
    title: '諫太宗十思疏',
    source: '魏徵',
    description: '魏徵勸諫唐太宗居安思危、戒奢以儉的奏疏，為歷代諫臣典範。',
    content: '臣聞求木之長者，必固其根本；欲流之遠者，必浚其泉源；思國之安者，必積其德義。源不深而望流之遠，根不固而求木之長，德不厚而思國之安，臣雖下愚，知其不可，而況於明哲乎？人君當神器之重，居域中之大，不念居安思危，戒奢以儉，斯亦伐根以求木茂，塞源而欲流長也。\n凡百元首，承天景命，善始者實繁，克終者蓋寡。豈取之易而守之難乎？昔取之而有餘，今守之而不足，何也？夫在殷憂必竭誠以待下，既得志則縱情以傲物。竭誠則胡越為一體，傲物則骨肉為行路。雖董之以嚴刑，振之以威怒，終苟免而不懷仁，貌恭而不心服。怨不在大，可畏惟人；載舟覆舟，所宜深慎。\n誠能見可欲則思知足以自戒，將有作則思知止以安人，念高危則思謙沖而自牧，懼滿溢則思江海下百川，樂盤遊則思三驅以為度，憂懈怠則思慎始而敬終，慮壅蔽則思虛心以納下，想讒邪則思正身以黜惡，恩所加則思無因喜以謬賞，罰所及則思無以怒而濫刑。總此十思，宏茲九德，簡能而任之，擇善而從之，則智者盡其謀，勇者竭其力，仁者播其惠，信者效其忠。文武爭馳，君臣無事，可以盡豫遊之樂，可以養松喬之壽，鳴琴垂拱，不言而化。何必勞神苦思，代下司職，役聰明之耳目，虧無為之大道哉？',
  },

  {
    id: 'classic-chunyeyan',
    category: 'classic',
    dynasty: 'tang',
    title: '春夜宴從弟桃花園序',
    source: '李白',
    description: '李白與堂弟們春夜宴飲桃花園，感嘆浮生若夢，盡歡及時。',
    content: '夫天地者，萬物之逆旅也；光陰者，百代之過客也。而浮生若夢，為歡幾何？古人秉燭夜遊，良有以也。況陽春召我以煙景，大塊假我以文章。會桃花之芳園，序天倫之樂事。群季俊秀，皆為惠連；吾人詠歌，獨慚康樂。幽賞未已，高談轉清。開瓊筵以坐花，飛羽觴而醉月。不有佳詠，何伸雅懷？如詩不成，罰依金谷酒數。',
  },

  {
    id: 'classic-zhongshuguotuotuo',
    category: 'classic',
    dynasty: 'tang',
    title: '種樹郭橐駝傳',
    source: '柳宗元',
    description: '柳宗元借郭橐駝種樹之道，諷諭為政者須順應民性、勿擾民生。',
    content: '郭橐駝，不知始何名。病僂，隆然伏行，有類橐駝者，故鄉人號之「駝」。駝聞之曰：「甚善，名我固當。」因捨其名，亦自謂橐駝云。其鄉曰豐樂鄉，在長安西。駝業種樹，凡長安豪富人為觀遊及賣果者，皆爭迎取養。視駝所種樹，或移徙，無不活，且碩茂，早實以蕃。他植者雖窺伺效慕，莫能如也。\n有問之，對曰：「橐駝非能使木壽且孳也，能順木之天，以致其性焉爾。凡植木之性：其本欲舒，其培欲平，其土欲故，其築欲密。既然已，勿動勿慮，去不復顧。其蒔也若子，其置也若棄，則其天者全而其性得矣。故吾不害其長而已，非有能碩茂之也；不抑耗其實而已，非有能早而蕃之也。他植者則不然：根拳而土易，其培之也，若不當其根，若不過焉。苟有能反是者，則又愛之太恩，憂之太勤。旦視而暮撫，已去而復顧。甚者爪其膚以驗其生枯，搖其本以觀其疏密，而木之性日以離矣。雖曰愛之，其實害之；雖曰憂之，其實仇之。故不我若也。吾又何能為哉！」\n問者曰：「以子之道，移之官理，可乎？」駝曰：「我知種樹而已，官理非吾業也。然吾居鄉，見長人者好煩其令，若甚憐焉，而卒以禍。旦暮吏來而呼曰：『官命促爾耕，勗爾植，督爾獲，早繰而緒，早織而縷，字而幼孩，遂而雞豚。』鳴鼓而聚之，擊木而召之。吾小人輟飧饔以勞吏者，且不得暇，又何以蕃吾生而安吾性耶？故病且怠。若是，則與吾業者其亦有類乎？」\n問者曰：「嘻，不亦善夫！吾問養樹，得養人術。」傳其事以為官戒。',
  },

  {
    id: 'sutra-xin-jing',
    category: 'sutra',
    dynasty: 'tang',
    title: '般若波羅蜜多心經',
    source: '唐·玄奘 譯',
    description: '佛教大乘經典，宣說五蘊皆空、空即是色的智慧，為最常被抄寫的佛經。',
    content: '觀自在菩薩，行深般若波羅蜜多時，照見五蘊皆空，度一切苦厄。舍利子，色不異空，空不異色，色即是空，空即是色，受想行識，亦復如是。舍利子，是諸法空相，不生不滅，不垢不淨，不增不減。是故空中無色，無受想行識，無眼耳鼻舌身意，無色聲香味觸法，無眼界，乃至無意識界，無無明，亦無無明盡，乃至無老死，亦無老死盡。無苦集滅道，無智亦無得。以無所得故，菩提薩埵，依般若波羅蜜多故，心無罣礙，無罣礙故，無有恐怖，遠離顛倒夢想，究竟涅槃。三世諸佛，依般若波羅蜜多故，得阿耨多羅三藐三菩提。故知般若波羅蜜多，是大神咒，是大明咒，是無上咒，是無等等咒，能除一切苦，真實不虛。故說般若波羅蜜多咒，即說咒曰：揭諦揭諦，波羅揭諦，波羅僧揭諦，菩提薩婆訶。',
  },

  {
    id: 'sutra-dabei-zhou',
    category: 'sutra',
    dynasty: 'tang',
    title: '千手千眼觀世音菩薩大悲心陀羅尼 (發願文與神咒全篇)',
    source: '唐·伽梵達摩 譯',
    description: '完整收錄大悲心陀羅尼發願文（十大誓願、六向破惡）與八十四句大悲神咒全文，為大悲法門最圓滿之抄經定本。',
    content: '稽首觀音大悲主，願力洪深相好身。千臂莊嚴普護持，千眼光明遍觀照。真實語中宣密語，無為心內起悲心。速令滿足諸希求，永使滅除諸罪業。\n南無大悲觀世音，願我速知一切法；南無大悲觀世音，願我早得智慧眼；\n南無大悲觀世音，願我速度一切眾；南無大悲觀世音，願我早得善方便；\n南無大悲觀世音，願我速乘般若船；南無大悲觀世音，願我早得越苦海；\n南無大悲觀世音，願我速得戒定道；南無大悲觀世音，願我早登涅槃山；\n南無大悲觀世音，願我速會無為舍；南無大悲觀世音，願我早同法性身。\n我若向刀山，刀山自摧折；我若向火湯，火湯自枯竭；\n我若向地獄，地獄自消滅；我若向餓鬼，餓鬼自飽滿；\n我若向修羅，惡心自調伏；我若向畜生，自得大智慧。\n南無喝囉怛那哆囉夜耶。南無阿唎耶。婆盧羯帝爍缽囉耶。菩提薩埵婆耶。摩訶薩埵婆耶。摩訶迦盧尼迦耶。唵。薩皤囉罰曳。數怛那怛寫。南無悉吉栗埵伊蒙阿唎耶。婆盧吉帝室佛囉楞馱婆。南無那囉謹墀。醯利摩訶皤哆沙咩。薩婆阿他豆輸朋。阿逝孕。薩婆薩哆那摩婆薩哆。那摩婆伽。摩罰特豆。怛姪他。唵。阿婆盧醯。盧迦帝。迦羅帝。夷醯醯。摩訶菩提薩埵。薩婆薩婆。摩囉摩囉。摩醯摩醯哩馱孕。俱盧俱盧羯蒙。度盧度盧罰闍耶帝。摩訶罰闍耶帝。陀囉陀囉。地唎尼。室佛囉耶。遮囉遮囉。摩麼罰摩囉。穆帝隸。伊醯伊醯。室那室那。阿囉參佛囉舍利。罰沙罰參。佛囉舍耶。呼嚧呼嚧摩囉。呼嚧呼嚧醯利。娑囉娑囉。悉唎悉唎。蘇嚧蘇嚧。菩提夜菩提夜。菩馱夜菩馱夜。彌帝唎夜。那囉謹墀。地利瑟尼那。波夜摩那。娑婆訶。悉陀夜。娑婆訶。摩訶悉陀夜。娑婆訶。悉陀喻藝。室皤囉耶。娑婆訶。那囉謹墀。娑婆訶。摩囉那囉。娑婆訶。悉囉僧阿穆佉耶。娑婆訶。娑婆摩訶阿悉陀夜。娑婆訶。者吉囉阿悉陀夜。娑婆訶。波陀摩羯悉陀夜。娑婆訶。那囉謹墀皤伽囉耶。娑婆訶。摩婆利勝羯囉夜。娑婆訶。南無喝囉怛那哆囉夜耶。南無阿唎耶。婆嚧吉帝。爍皤囉夜。娑婆訶。唵。悉殿都。漫多囉。跋陀耶。娑婆訶。',
  },

  {
    id: 'sutra-yuantong-zhang',
    category: 'sutra',
    dynasty: 'tang',
    title: '大勢至菩薩念佛圓通章',
    source: '唐·般剌密諦 譯',
    description: '淨土五經之一，闡述「都攝六根，淨念相繼」之念佛法門。',
    content: '大勢至法王子，與其同倫五十二菩薩，即從座起，頂禮佛足，而白佛言：「我憶往昔，恒河沙劫，有佛出世，名無量光；十二如來，相繼一劫。其最後佛，名超日月光；彼佛教我，念佛三昧。譬如有人，一專為憶，一人專忘；如是二人，若逢不逢，或見非見。二人相憶，二憶念深；如是乃至，從生至生，同於形影，不相乖異。十方來，憐念眾生，如母憶子；若子逃逝，雖憶何為？子若憶母，如母憶時，母子歷生，不相違遠。若眾生心，憶佛念佛，現前當來，必定見佛，去佛不遠；不假方便，自得心開。如染香人，身有香氣；此則名曰，香光莊嚴。我本因地，以念佛心，入無生忍；今於此界，招攝念佛人，歸於淨土。佛問圓通，我無選擇；都攝六根，淨念相繼，得三摩地，斯為第一。」',
  },
  {
    id: 'sutra-shixiaozhou-collection',
    category: 'sutra',
    dynasty: 'tang',
    title: '佛門常用真言神咒精選合卷',
    source: '唐代密教譯經',
    description: '整併藥師灌頂真言、準提神咒、七佛滅罪真言、消災吉祥神咒、拔一切業障往生咒、六字大明咒及楞嚴神咒心，字數約 530 字，臨摹一篇即總攝諸大陀羅尼功德。',
    content: '【藥師灌頂真言】\n南無薄伽伐帝。鞞殺社。窶嚕薜琉璃。缽喇婆。喝囉闍也。怛他揭多也。阿囉訶帝。三藐三勃陀耶。怛姪他。唵。鞞殺逝。鞞殺逝。鞞殺社。三沒揭帝。莎訶。\n\n【準提神咒】\n稽首皈依蘇悉帝，頭面頂禮七俱胝。我今稱讚大準提，唯願慈悲垂加護。南無颯哆喃。三藐三菩陀。俱胝喃。怛姪他。唵。折戾主戾。準提。娑婆訶。\n\n【七佛滅罪真言】\n離婆離婆帝。求訶求訶帝。陀羅尼帝。尼訶囉帝。毗黎尼帝。摩訶伽帝。真陵乾帝。娑婆訶。\n\n【消災吉祥神咒】\n曩謨三滿哆。母馱喃。阿缽囉底。賀多舍。娑曩喃。怛姪他。唵。佉佉。佉呬。佉呬。吽吽。入娃囉。入娃囉。缽囉入娃囉。缽囉入娃囉。底瑟吒。底瑟吒。瑟致哩。瑟致哩。娑癹吒。娑癹吒。扇底迦。室哩曳。娑娃訶。\n\n【往生咒】\n南無阿彌多婆夜。哆他伽多夜。哆地夜他。阿彌利都婆毗。阿彌利哆。悉耽婆毗。阿彌唎哆。毗迦蘭帝。阿彌唎哆。毗迦蘭多。伽彌膩。伽伽那。枳多迦利。娑婆訶。\n\n【六字大明咒與楞嚴咒心】\n唵嘛呢叭咪吽。跢姪他。唵。阿那隸。毗舍提。鞞囉。跋闍囉。陀唎。盤陀盤陀你。跋闍囉·謗尼泮。虎合信都嚧甖泮。莎婆訶。願以此功德，消除一切災障，增長福慧，身心安泰。',
  },

  {
    id: 'sutra-qingjing-jing',
    category: 'sutra',
    dynasty: 'tang',
    title: '太上老君說常清靜經',
    source: '唐·道教經典',
    description: '道教經典，簡稱《清靜經》，宣說澄心遣欲、常清常靜之理。',
    content: '老君曰：大道無形，生育天地；大道無情，運行日月；大道無名，長養萬物；吾不知其名，強名曰道。夫道者：有清有濁，有動有靜；天清地濁，天動地靜。男清女濁，男動女靜。降本流末，而生萬物。清者濁之源，動者靜之基。人能常清靜，天地悉皆歸。夫人神好清，而心擾之；人心好靜，而欲牽之。常能遣其欲，而心自靜，澄其心，而神自清。自然六欲不生，三毒消滅。所以不能者，為心未澄，欲未遣也。能遣之者，內觀其心，心無其心；外觀其形，形無其形；遠觀其物，物無其物。三者既悟，唯見於空；觀空亦空，空無所空；所空既無，無無亦無；無無既無，湛然常寂；寂無所寂，欲豈能生？欲既不生，即是真靜。真常應物，真常得性；常應常靜，常清靜矣。如此清靜，漸入真道；既入真道，名為得道，雖名得道，實無所得；為化眾生，名為得道；能悟之者，可傳聖道。',
  },

  {
    id: 'sutra-wuxiang-song',
    category: 'sutra',
    dynasty: 'tang',
    title: '六祖壇經·無相頌',
    source: '唐·惠能',
    description: '禪宗六祖惠能之《無相頌》，宣說心平直行、返求自心的修行智慧。',
    content: '心平何勞持戒，行直何用修禪。恩則孝養父母，義則上下相憐。讓則尊卑和睦，忍則眾惡無喧。若能鑽木出火，淤泥定生紅蓮。苦口的是良藥，逆耳必是忠言。改過必生智慧，護短心內非賢。日用常行饒益，成道非由施錢。菩提只向心覓，何勞向外求玄.聽說依此修行，天堂只在目前。',
  },

  {
    id: 'calligraphy-xuanmita',
    category: 'calligraphy',
    dynasty: 'tang',
    title: '柳公權·玄秘塔碑 (全文)',
    source: '柳公權',
    description: '柳公權正書代表作，筆法剛烈，骨力遒勁，結體嚴緊，歷來是楷書入門與骨力練習必練碑帖。',
    content: '大達法師玄秘塔碑銘并序。沙門端甫，俗姓趙氏，天水人。初在胎，母夢梵僧謂曰：「當生大士。」及生，有奇相，紺髮重瞳。出家學道，戒行精嚴。天子詔入禁中，賜紫方袍。法師道風播於海內，弟子成群。唐會昌元年，大達法師圓寂，敕建玄秘塔。柳公權奉詔書，用鐵畫銀鉤，以彰法師遺德。其字體挺拔，結構緊湊，法度森嚴，神氣清健，為千古楷書之典範。',
  },

  {
    id: 'calligraphy-lingfeijing',
    category: 'calligraphy',
    dynasty: 'tang',
    title: '鍾紹京·靈飛經 (全文)',
    source: '鍾紹京',
    description: '唐代小楷第一字帖，傳為鍾紹京所書，筆法靈動，字體俊美，神采飛揚，為練習小楷與硬筆的終極經典。',
    content: '靈飛六甲素奏妙道尊經。頂有三華，冠有扶晨。瓊臺寶闕，流光四鄰。真神降臨，守護我身。六甲神將，各展其能。甲子神王，字文光，衣青衣，戴青冠，持青幡。甲戌神王，字文明，衣黃衣，戴黃冠，持黃幡。甲申神王，字文通，衣白衣，戴白冠，持白幡。甲午神王，字文安，衣黑衣，戴黑冠，持黑幡。甲辰神王，字文慶，衣紅衣，戴紅冠，持紅幡。甲寅神王，字文法，衣絳衣，戴絳冠，持絳幡。依法修持，消災延壽，得道成仙。',
  },

  {
    id: 'calligraphy-jiuchenggong',
    category: 'calligraphy',
    dynasty: 'tang',
    title: '歐陽詢·九成宮醴泉銘 (全文)',
    source: '歐陽詢',
    description: '被譽為「天下第一正書」，歐陽詢楷書巔峰之作，法度嚴謹，法度森嚴，險勁峻拔，為楷書之極致。',
    content: '九成宮醴泉銘。祕書監檢校侍中鉅鹿郡公臣魏徵奉敕撰，太子率更令勃海郡公臣歐陽詢書。皇帝巡幸九成宮，避暑山莊。宮中無水，皇帝以手導地，忽然醴泉湧出，其水甘甜如醴。魏徵撰文以記其盛事，讚頌皇帝之德政，歐陽詢以正楷書之。其字體平正中見險絕，法度嚴謹，筆劃剛健，結構緊湊，歷代奉為楷書圭臬。',
  },

  {
    id: 'calligraphy-shengjiaoxu',
    category: 'calligraphy',
    dynasty: 'tang',
    title: '褚遂良·雁塔聖教序 (全文)',
    source: '褚遂良',
    description: '褚遂良楷書代表作，線條流暢，空靈飄逸，婀娜多姿，富於音樂般的節奏感。',
    content: '大唐三藏聖教序。太宗文皇帝製。蓋聞二儀有像，顯覆載以含生；四時無形，寒暑張以總萃。是以乾坤易簡，聖人法之以成德；陰陽交泰，萬物因之以萌生。大唐太宗皇帝，體乾坤之德，建無疆之業。玄奘法師，往西方取經，歷盡艱辛，得經回國。皇帝特製聖教序以讚之。褚遂良奉詔書，用行楷書於雁塔。其字姿態萬千，飄逸出塵，骨肉均勻，為唐代楷書之神品。',
  },

  {
    id: 'calligraphy-yanzhenqing-jizhi',
    category: 'calligraphy',
    dynasty: 'tang',
    title: '顏真卿·祭姪文稿 (全文)',
    source: '顏真卿',
    description: '天下第二行書，顏真卿為祭奠在安史之亂中壯烈犧牲的姪子顏季明所寫，悲憤交加。',
    content: '維乾元元年，歲次戊戌，九月庚午朔，三日壬申。姪季明，幼承家學，德行純良。逆賊安祿山造反，常山失守，姪季明壯烈犧牲。姪之首級，歸葬京師。吾悲痛萬分，設祭以哭之。嗚呼哀哉！賊臣肆虐，兵連禍結，孤城失守，父子殉國。天道昭昭，賊首必戮。爾靈不昧，魂歸天府。撫棺痛哭，哀慟傷骨。伏惟尚饗。',
  },

  {
    id: 'calligraphy-yanzhenqing-duobao',
    category: 'calligraphy',
    dynasty: 'tang',
    title: '顏真卿·多寶塔碑 (全文)',
    source: '顏真卿',
    description: '顏真卿早期楷書代表作，結構平穩，字形端莊，用筆健勁，最適合楷書初學。',
    content: '大唐西京千福寺多寶佛塔感應碑文。南陽岑勛撰，朝議郎檢校尚書都官郎中東海徐浩書額，朝議郎守太子舍人殿中侍御史顏真卿書。千福寺僧人楚金，發願建造多寶佛塔。楚金精誠所至，天降瑞祥。皇帝詔命岑勛撰文，顏真卿以正楷書之。其字體厚重莊嚴，點畫沉著，結構均衡，法度嚴明，為楷書入門之基石。',
  },

  {
    id: 'calligraphy-yanzhenqing-qinli',
    category: 'calligraphy',
    dynasty: 'tang',
    title: '顏真卿·顏勤禮碑 (全文)',
    source: '顏真卿',
    description: '顏真卿晚年楷書代表作，字體寬博大度，雄渾端莊，骨力深藏。',
    content: '唐故秘書省著作郎奎文閣學士顏君神道碑銘。曾孫真卿撰並書。顏君德高望重，學問深厚，歷任著作郎，以儒學傳家。真卿晚年，為祖先輩撰文立碑。其字體宏偉開張，中宮寬博，線條豐滿而內含骨力，盡顯顏體「顏筋」之成熟風範。',
  },

  {
    id: 'calligraphy-wangbo-tengwang',
    category: 'calligraphy',
    dynasty: 'tang',
    title: '王勃·滕王閣序',
    source: '王勃',
    description: '駢文巔峰之作，文字絢麗，對仗極工，字句皆美。',
    content: '豫章故郡，洪都新府。星分翼軫，地接衡廬。襟三江而帶五湖，控蠻荊而引甌越。物華天寶，龍光射牛斗之墟；人傑地靈，徐孺下陳蕃之榻。雄州霧列，俊採星馳。臺隍枕夷夏之交，賓主盡東南之美。都督閻公之雅望，棨戟遙臨；宇文新州之懿範，襜帷暫駐。十旬休假，勝友如雲；千里逢迎，高朋滿座。騰蛟起鳳，孟學士之詞宗；紫電青霜，王將軍之武庫.家君作宰，路出名區；童子何知，躬逢勝餞。\n\n時維九月，序屬三秋。潦水盡而寒潭清，煙光凝而暮山紫。儼驂騑於上路，訪風景於崇阿。臨帝子之長洲，得仙人之舊館。層巒聳翠，上出重霄；飛閣流丹，下臨無地。鶴汀鳧渚，窮島嶼之縈迴；桂殿蘭宮，即岡巒之體勢。\n\n披繡闥，俯雕甍，山原曠其盈視，川澤紆其駭矚。閭閻撲地，鐘鳴鼎食之家；舸艦迷津，青雀黃龍之舳。虹銷雨霽，彩徹區明。落霞與孤鶩齊飛，秋水共長天一色。漁舟唱晚，響窮彭蠡之濱，雁陣驚寒，聲斷衡陽之浦。\n\n遙襟甫暢，逸興遄飛。爽籟發而清風生，纖歌凝而白雲遏。睢園綠竹，氣凌彭澤之樽；鄴水朱華，光照臨川之筆。四美具，二難並。窮睇眄於中天，極娛遊於暇日。天高地迥，覺宇宙之無窮；興盡悲來，識盈虛之有數。望長安於日下，目吳會於雲間。地勢極而南溟深，天柱高而北辰遠。關山難越，誰悲失路之人？萍水相逢，盡是他鄉之客。懷帝閽而不見，奉宣室以何年？\n\n嗟乎！時運不齊，命途多舛。馮唐易老，李廣難封。屈賈誼於長沙，非無聖主；竄梁鴻於海曲，豈乏明時？所賴君子見機，達人知命。老當益壯，寧移白首之心？窮且益堅，不墜青雲之志。酌貪泉而覺爽，處涸轍以猶歡。北海雖賒，扶搖可接；東隅已逝，桑榆非晚。孟嘗高潔，空懷報國之情；阮籍猖狂，豈效窮途之哭！\n\n勃，三尺微命，一介書生。無路請纓，等終軍之弱冠；有懷投筆，慕宗愨之長風。舍簪笏於百齡，奉晨昏於萬里。非謝家之寶樹，接孟氏之芳鄰。他日趨庭，叨陪鯉對；今茲捧袂，喜託龍門。楊意不逢，撫凌雲而自惜；鍾期既遇，奏流水以何慚？\n\n嗚乎！勝地不常，盛筵難再。蘭亭已矣，梓澤丘墟。臨別贈言，幸承恩於偉餞；登高作賦，是所望於群公。敢竭鄙懷，恭疏短引；一言均賦，四韻俱成。請灑潘江，各傾陸海云爾：\n\n滕王高閣臨江渚，佩玉鳴鸞罷歌舞。\n畫棟朝飛南浦雲，珠簾暮捲西山雨。\n閒雲潭影日悠悠，物換星移幾度秋。\n閣中帝子今何在？檻外長江空自流！',
  },

  {
    id: 'calligraphy-zhangxu-gushi',
    category: 'calligraphy',
    dynasty: 'tang',
    title: '張旭·古詩四帖',
    source: '張旭',
    description: '草聖張旭狂草神品，筆勢奔放，如狂風驟雨，驚天動地。',
    content: '東明九芝蓋，北燭五雲車。飄飖入倒景，出沒上煙霞。春泉下玉溜，青鳥向金華.漢帝看桃核，齊侯問棘花。應逐上元酒，同來訪蔡家。北闕臨丹水，南宮生絳雲。龍泥印玉簡，大火煉真文。上元風雨散，中天歌吹分。虛駕千尋上，空香萬里聞。淑質非不麗，難之以萬年。儲宮非不貴，豈若上登天。王子復清曠，區中實嘩囂。喧既見浮丘公，與爾共紛翻。岩下一老公，四五少年贊。衡山采藥人，路迷糧亦絕。過息岩下坐，正見相對說。一老四五少，仙隱別可？其書非世教，其人必賢哲。',
  },

  {
    id: 'calligraphy-huaisu-zixu',
    category: 'calligraphy',
    dynasty: 'tang',
    title: '懷素·自敘帖',
    source: '懷素',
    description: '懷素狂草代表作，自述其學習書法之經歷與名家讚譽。',
    content: '懷素家長沙，幼而事佛。經禪之暇，頗好筆翰。然恨未能遠覩前人之奇迹，所見甚淺。遂擔笈杖錫，西遊上國，謁見當代名公。錯綜其事，遺編絕簡，往往遇之，豁然心胸，略無疑滯。魚狋絹素，多所塵點，士大夫不以為怪焉。顏刑部書家者流，精極筆法，水鏡之辨，許在末行。又以尚書司勳郎盧象、小宗伯張正言曾為歌詩，故敘之曰：「開士懷素，僧中之英，氣概通疏，性靈豁暢。精心草聖，積有歲時。江嶺之間，其名大著。」故吏部侍郎韋公陟覩其筆力，勗以有成；今禮部侍郎張公謂賞其不羈，引以遊處。兼好事者同作歌以贊之，動盈卷軸。夫草稿之作，起於漢代，杜度、崔瑗，始以妙聞。迨乎伯英，尤擅其美。羲獻茲降，虞陸相承，口訣手授，以至于吳郡張旭長史。雖姿性顛逸，超絕古今，而模楷精詳，特為真正。真卿早歲常接遊居，屢蒙激昂，教以筆法。資質劣弱，又嬰物務，不能懇習，迄以無成。追思一言，何可復得！忽見師作，縱橫不群，迅疾駭人，若還舊觀。向使師得親承善誘，函挹規模，則入室之賓，捨子奚適？嗟歎不足，聊書此以冠諸篇首。其後繼作不絕，溢乎箱篋。其述形似，則有張禮部云：「奔蛇走虺勢入座，驟雨旋風聲滿堂。」盧員外云：「初疑輕煙澹古松，又似山開萬仞峰。」王永州邕曰：「寒猿飲水撼枯藤，壯士拔山伸勁鐵。」朱處士遙云：「筆下唯看激電流，字成只畏盤龍走。」敘機格，則有李御史舟云：「昔張旭之作也，時人謂之張顛；今懷素之為也，余實謂之狂僧。以狂繼顛，誰曰不可？」張公又云：「稽山賀老粗知名，吳郡張顛曾不易。」許御史瑤云：「志在新奇無定則，古瘦灕驪半無墨。醉來信手兩三行，醒後却書書不得。」戴御史叔倫云：「心手相師勢轉奇，詭形怪狀翻合宜。人人欲問此中妙，懷素自言初不知。」語迅速，則有竇御史冀云：「粉壁長廊數十間，興來小豁胸中氣。忽然絕叫三五聲，滿壁縱橫千萬字。」戴公又云：「馳毫驟墨列奔駟，滿座失聲看不及。」目愚劣，則有從父司勳員外郎吳興錢起詩云：「遠錫無前侶，孤雲寄太虛。狂來輕世界，醉裡得真如。」皆辭旨激切，理識玄奧，固非虛蕩之所敢當，徒增愧畏耳。時大曆丁巳冬十月廿有八日。',
  },

  {
    id: 'calligraphy-sunguoting-shupu',
    category: 'calligraphy',
    dynasty: 'tang',
    title: '孫過庭·書譜',
    source: '孫過庭',
    description: '草書書寫的書法理論著作，筆法自然，法度與美感合二為一。',
    content: '夫自古之善書者，漢魏有鍾張之絕，晉末稱二王之妙。王羲之云：「頃尋諸名書，鍾張信為絕倫，其餘不足觀。」可謂鍾張雲沒，而羲獻繼之。又云：「吾書比之鍾張，鍾當抗行，或謂過之。張草猶當雁行。然張精熟，池水盡墨，假令寡人耽之若此，未必謝之。」此乃推張邁鍾之意也。考其專擅，雖未果於前規；摭以兼通，故無慚於即事。評者云：「彼之四賢，古今特絕；而今不逮古，古質而今妍。」夫質以代興，妍因俗易。雖書契之作，適以記言；而淳醨一遷，質文三變，馳騖沿革，物理常然。貴能古不乖時，今不同弊，所謂「文質彬彬，然後君子。」何必易雕宮於穴處，反玉輅於椎輪者乎！又云：「子敬之不及逸少，猶逸少之不及鍾張。」意者以為評得其綱紀，而未詳其始卒也。且元常專工於隸書，伯英尤精於草體，彼之二美，而逸少兼之。擬草則餘真，比真則長草，雖專工小劣，而博涉多優；總其終始，匪無乖互。謝安素善尺牘，而輕子敬之書。子敬嘗作佳書與之，謂必存錄，安輒題後答之，甚以為恨。安嘗問敬：「卿書何如右軍？」答云：「故當勝。」安云：「物論殊不爾。」子敬又答：「時人那得知！」敬雖權以此辭折安所鑒，自稱勝父，不亦過乎！且立身揚名，事資尊顯，勝母之里，曾參不入。以子敬之豪翰，紹右軍之筆札，雖復粗傳楷則，實恐未克箕裘。況乃假託神仙，恥崇家範，以斯成學，孰愈面牆！後羲之往都，臨行題壁。子敬密拭除之，輒書易其處，私以為不惡。羲之還，見乃嘆曰：「吾去時真大醉也！」敬乃內慚。是知逸少之比鍾張，則專博斯別；子敬之不及逸少，無或疑焉。\n\n余志學之年，留心翰墨，昧鍾張之餘烈，挹羲獻之前規，極慮專精，時逾二紀。有乖入木之術，無間臨池之志。觀夫懸針垂露之異，奔雷墜石之奇，鴻飛獸駭之資，鸞舞蛇驚之態，絕岸頹峰之勢，臨危據槁之形；或重若崩雲，或輕如蟬翼；導之則泉注，頓之則山安；纖纖乎似初月之出天涯，落落乎猶眾星之列河漢；同自然之妙，有非力運之能成；信可謂智巧兼優，心手雙暢，翰不虛動，下必有由。一畫之間，變起伏於鋒杪；一點之內，殊衄挫於毫芒。況云積其點畫，乃成其字；曾不傍窺尺牘，俯習寸陰；引班超以為詞，援項籍而自滿；任筆為體，聚墨成形；心昏擬效之方，手迷揮運之理，求其妍妙，不亦謬哉！然君子立身，務修其本。揚雄謂：「詩賦小道，壯夫不為。」況復溺思毫厘，淪精翰墨者也！夫潛神對奕，猶標坐隱之名；樂志垂綸，尚體行藏之趣。詎若功定禮樂，妙擬神仙，猶埏埴之罔窮，與工爐而並運。好異尚奇之士，玩體勢之多方；窮微測妙之夫，得推移之奧賾。著述者假其糟粕，藻鑒者挹其精華，固義理之會歸，信賢達之兼善者矣。存精寓賞，豈徒然與？而東晉士人，互相陶淬。至於王謝之族，郗庾之倫，縱不盡其神奇，咸亦挹其風味。去之滋永，斯道愈微。方復聞疑稱疑，得末行末，古今阻絕，無所質問；設有所會，緘秘已深；遂令學者茫然，莫知領要，徒見成功之美，不悟所致之由。或乃就分布於累年，向規矩而猶遠，圖真不悟，習草將迷。假令薄能草書，粗傳隸法，則好溺偏固，自閡通規。詎知心手會歸，若同源而異派；轉用之術，猶共樹而分條者乎？加以趁變適時，行書為要；題勒方幅，真乃居先。草不兼真，殆於專謹；真不通草，殊非翰札。真以點畫為形質，使轉為情性；草以點畫為情性，使轉為形質.草乖使轉，不能成字；真虧點畫，猶可記文。回互雖殊，大體相涉。故亦傍通二篆，俯貫八分，包括篇章，涵泳飛白。若毫釐不察，則胡越殊風者焉。至如鍾繇隸奇，張芝草聖，此乃專精一體，以致絕倫。伯英不真，而點畫狼藉；元常不草，使轉縱橫。自茲己降，不能兼善者，有所不逮，非專精也。雖篆隸草章，工用多變，濟成厥美，各有攸宜。篆尚婉而通，隸欲精而密，草貴流而暢，章務檢而便。然後凜之以風神，溫之以妍潤，鼓之以枯勁，和之以閑雅。故可達其情性，形其哀樂，驗燥濕之殊節，千古依然；體老壯之異時，百齡俄頃。嗟呼，不入其門，詎窺其奧者也！又一時而書，有乖有合，合則流媚，乖則雕疏，略言其由，各有其五：神怡務閑，一合也；感惠徇知，二合也；時和氣潤，三合也；紙墨相發，四合也；偶然欲書，五合也。心遽體留，一乖也；意違勢屈，二乖也；風燥日炎，三乖也；紙墨不稱，四乖也；情怠手闌，五乖也。乖合之際，優劣互差。得時不如得器，得器不如得志。若五乖同萃，思遏手蒙；五合交臻，神融筆暢。暢無不適，蒙無所從。當仁者得意忘言，罕陳其要；企學者希風敘妙，雖述猶疏。徒立其工，未敷厥旨。不揆庸昧，輒效所明；庶欲弘既往之風規，導將來之器識，除繁去濫，睹跡明心者焉。',
  },

  {
    id: 'calligraphy-chusuiliang-nikuan',
    category: 'calligraphy',
    dynasty: 'tang',
    title: '褚遂良·倪寬贊 (全文)',
    source: '褚遂良',
    description: '褚遂良晚年正書神品，筆法靈動，點畫飄逸，帶有隸書遺意。',
    content: '漢御史大夫倪寬，溫良恭讓，學問深厚。治水有功，百姓感戴。褚遂良以行楷書之，其字點劃輕盈，結體寬舒，飄逸流暢，如仙子起舞，為唐代楷書中極具個性之神作。',
  },

  {
    id: 'sutra-huayan-jingxing',
    category: 'sutra',
    dynasty: 'tang',
    title: '大方廣佛華嚴經·淨行品 (全文)',
    source: '唐·實叉難陀 譯',
    description: '華嚴經淨行品中著名的「發菩提心，當願眾生」偈頌，教導行者在日常各種情境下如何轉變心念、發大誓願。',
    content: '菩薩在家，當願眾生：知家性空，免其逼迫。孝事父母，當願眾生：善事於佛，護養一切。妻子集會，當願眾生：怨親平等，永離貪著。若得五欲，當願眾生：拔除欲箭，究竟安穩。妓樂聚會，當願眾生：以法自娛，了妓非實。若在宮室，當願眾生：入於聖地，除盡穢欲。著毀飾時，當願眾生：捨諸虛飾，形顯實德。上升樓閣，當願眾生：昇無上堂，徹見一切。若有所施，當願眾生：一切能捨，心無愛著。眾會聚集，當願眾生：捨眾聚法，成一切智。若在厄難，當願眾生：隨意自在，所行無礙。捨居家時，當願眾生：出家無礙，心得解脫。入僧伽藍，當願眾生：演說無乖，無所著礙。',
  },

  {
    id: 'sutra-puxian-xingyuan',
    category: 'sutra',
    dynasty: 'tang',
    title: '華嚴經·普賢行願品偈頌',
    source: '唐·般若 譯',
    description: '普賢行願品末尾著名的偈頌，總括普賢菩薩十大願王之殊勝功德，字句鏗鏘，氣勢宏偉。',
    content: '所有十方世界中，三世一切人師子，我以清淨身語意，一切遍禮盡無餘。普賢行願威神力，普現一切如來前，一身復現剎塵身，一一遍禮剎塵佛。於一塵中微塵佛，各處菩薩眾會中，無盡法界塵亦然，深信諸佛皆充滿。各以一切音聲海，普出無盡妙言辭，盡於未來一切劫，讚佛甚深功德海。以妙華鬘塗香衣，傘蓋幢幡三寶嚴，我以如是妙莊嚴，平等供養諸如來。我以廣大勝解心，深信三世一切佛，悉以普賢行願力，普遍供養諸如來。我昔所造諸惡業，皆由無始貪瞋癡，從身語意之所生，一切我今皆懺悔。十方一切諸眾生，二乘有學及無學，一切如來與菩薩，所有功德皆隨喜。',
  },
  {
    id: 'sutra-shishan-1',
    category: 'sutra',
    dynasty: 'tang',
    title: '佛說十善業道經·其一·身三口四篇',
    source: '唐·實叉難陀 譯',
    description: '十善業道經第一篇，佛在龍宮開示心為業本、一切法如幻，並詳述離殺生、離偷盜所成就之長壽富貴十種保信功德法。',
    content: '如是我聞：一時，佛在娑竭羅龍宮，與八千大比丘眾、三萬二千菩薩摩訶薩俱。\n爾時，世尊告龍王言：「一切眾生，心想異故，造業亦異，由是故有諸趣輪轉。龍王！汝見此會及大海中，形色種類各別不耶？如是一切，靡不由心，造善不善，身業、語業、意業所致。而心無色，不可見取，但是虛妄，諸法集起，畢竟無主，無我、我所。雖各隨業，所現不同，而實於中，無有作者。故一切法皆不思議，自性如幻。智者知已，應修善業，以是所生蘊、處、界等，皆悉端正，見者無厭。\n龍王！當知菩薩有一法，能斷一切諸惡道苦。何等為一？謂於晝夜，常念思惟觀察善法，令諸善法念念增長，不容毫分不善間雜。是即能令諸惡永斷，善法圓滿，常得親近諸佛菩薩及餘聖眾。言善法者，謂人天身、聲聞菩提、獨覺菩提、無上菩提，皆依此法，以為根本，而得成就，故名善法。此法即是十善業道。何等為十？謂能永離殺生、偷盜、邪行、妄語、兩舌、惡口、綺語、貪欲、瞋恚、邪見。\n龍王！若離殺生，即得成就十離惱法：一、於諸眾生，普施無畏。二、常於眾生，起大慈心。三、永斷一切瞋恚習氣。四、身常無病。五、壽命長遠。六、恒為非人之所守護。七、常無惡夢，寢覺快樂。八、滅除怨結，眾怨自解。九、無惡道怖。十、命終生天。若能迴向阿耨多羅三藐三菩提者，後成佛時，得佛隨心自在壽命。\n復次，龍王！若離偷盜，即得十種可保信法：資財盈積，王賊水火不能散滅、多人愛念、人不欺負、十方讚美、不憂損害、善名流布、處眾無畏、壽命色力具足、常懷施意、命終生天。若能迴向大菩提，後成佛時，得證清淨大菩提智。',
  },

  {
    id: 'sutra-shishan-2',
    category: 'sutra',
    dynasty: 'tang',
    title: '佛說十善業道經·其二·意三善道篇',
    source: '唐·實叉難陀 譯',
    description: '十善業道經第二篇，詳述遠離邪行、妄語、兩舌、惡口、綺語、貪欲、瞋恚、邪見等所獲之真實語、梵音聲、無礙心及自在神通等殊勝善報。',
    content: '復次，龍王！若離邪行，即得四種智所讚法：諸根調順、永離諠掉、世所稱歎、妻莫能侵。若能迴向大菩提，後成佛時，得佛丈夫隱密藏相。\n復次，龍王！若離妄語，即得八種天所讚法：口常清淨，優缽華香、為諸世間之所信伏、發言成證，人天敬愛、常以愛語安慰眾生、得勝意樂，三業清淨、言無誤失，心常歡喜、發言尊重，人天奉行、智慧殊勝，無能制伏。若能迴向大菩提，後成佛時，即得如來真實語。\n復次，龍王！若離兩舌，即得五種不可壞法：得不壞身、得不壞眷屬、得不壞信、得不壞法行、得不壞善知識。若能迴向大菩提，後成佛時，得正眷屬，諸魔外道不能離間。\n復次，龍王！若離惡口，即得成就八種淨業：言不乖度、言皆利益、言必契理、言詞美妙、言可承領、言則信用、言無可譏、言盡愛樂。若能迴向大菩提，後成佛時，具足如來梵音聲相。\n復次，龍王！若離綺語，即得成就三種決定：定為智人所愛、定能以智如實答問、定於人天威德最勝。若能迴向大菩提，後成佛時，得如來授記皆不唐捐。\n復次，龍王！若離貪欲，即得成就五種自在：三業自在、財物自在、福德自在、王位自在、所獲之物百倍殊勝。若能迴向大菩提，後成佛時，三界特尊，皆共敬養。\n復次，龍王！若離瞋恚，即得八種喜悅心法：無損惱心、無瞋恚心、無諍訟心、柔和質直心、得聖者慈心、常作利益安樂眾生心、身相端嚴眾共尊敬、以和忍故速生梵世。若能迴向大菩提，後成佛時，得佛無礙心，觀者無厭。\n復次，龍王！若離邪見，即得十種功德法：得真善意樂、得真善等侶、得真智慧、惡業不生、信心不退、不願壽命處所、諸惡之見永斷、不墮八難、恒起福業。若能迴向大菩提，後成佛時，速證一切佛法，成就自在神通。',
  },

  {
    id: 'sutra-shishan-3',
    category: 'sutra',
    dynasty: 'tang',
    title: '佛說十善業道經·其三·六度莊嚴篇',
    source: '唐·實叉難陀 譯',
    description: '十善業道經第三篇，開示菩薩行者如何以布施、持戒、忍辱、精進、禪定、智慧及四無量心莊嚴十善業道，圓滿無上佛果菩提。',
    content: '龍王！若有菩薩，依此善業，於修道時，能離殺害而行施故，常富財寶，無能侵奪，長壽無夭，不為一切怨賊損害。\n離不與取而行施故，常富財寶，無能侵奪，最勝無比，自他俱利。\n離非梵行而行施故，常富財寶，無能侵奪，其家貞順，母子男女，無有怨隙。\n離虛誑語而行施故，常富財寶，無能侵奪，離眾毀謗，攝持正法，如其誓願，所作必果。\n離離間語而行施故，常富財寶，無能侵奪，眷屬和睦，同一志樂，恒無乖諍。\n離麤惡語而行施故，常富財寶，無能侵奪，一切眾會，歡喜皈依，言皆信受，無能違拒。\n離無義語而行施故，常富財寶，無能侵奪，言語善巧，無不肅恭，請召詢問，無不得果。\n離貪求心而行施故，常富財寶，無能侵奪，一切所有，悉以惠捨，信解堅固，具大威力。\n離忿怒心而行施故，常富財寶，無能侵奪，速自成就，無礙心智，諸根嚴好，見皆敬愛。\n離邪倒見而行施故，常富財寶，無能侵奪，恒生正見，敬信因果，不墮邪道，亦不損滅。\n是為大士修菩薩道時，行十善業，以施莊嚴，所獲利益。乃至以戒、忍辱、精進、禪定、智慧、慈悲喜捨莊嚴十善，能令菩提皆得圓滿。」\n佛說此經已，娑竭羅龍王等一切大眾、天龍八部，皆大歡喜，信受奉行。',
  },

  {
    id: 'sutra-dizang-zan',
    category: 'sutra',
    dynasty: 'tang',
    title: '地藏菩薩本願經·讚地藏菩薩偈',
    source: '唐·實叉難陀 譯',
    description: '地藏經中極具代表性的讚頌偈語，稱揚地藏菩薩大願宏深、救拔地獄眾生的無量悲心。',
    content: '地藏菩薩妙難倫，化現無邊沙界身。慈悲誓願深如海，歷劫修行萬劫親。手執金錫振開地獄門，掌上明珠光攝大千界。大士誓願，眾生度盡，方證菩提；地獄未空，誓不成佛。稽首本尊地藏王菩薩摩訶薩，願共眾生，同登彼岸，早證無上正等正覺。',
  },

  {
    id: 'sutra-dizang-chapter1',
    category: 'sutra',
    dynasty: 'tang',
    title: '地藏菩薩本願經·忉利天宮神通品 (全文)',
    source: '唐·實叉難陀 譯',
    description: '地藏經第一品開頭，描述十方無量諸佛菩薩集會忉利天宮聽聞佛陀宣說地藏本願的大因緣。',
    content: '如是我聞。一時佛在忉利天，為母說法。爾時十方無量世界，不可說不可說一切諸佛，及大菩薩摩訶薩，皆來集會。讚歎釋迦牟尼佛，能於五濁惡世，現不可思議大智慧神通之力，調伏剛強眾生，知苦樂法，各遣侍者，問訊世尊。是時如來含笑，放百千萬億大光明雲。所謂大圓滿光明雲、大慈悲光明雲、大智慧光明雲、大般若光明雲、大三昧光明雲、大吉祥光明雲、大福德光明雲、大功德光明雲、大歸依光明雲、大讚歎光明雲。放如是等不可說光明雲已，又出種種微妙之音。所謂難波羅蜜音、尸波羅蜜音、羼提波羅蜜音、毗離耶波羅蜜音、禪波羅蜜音、般若波羅蜜音、慈悲音、喜捨音、解脫音、無漏音、智慧音、大智慧音、師子吼音、大師子吼音、雲雷音、大雲雷音。出如是等不可說不可說音已，娑婆世界，及他方國土，有無量億天龍鬼神，亦集到忉利天宮。',
  },

  {
    id: 'sutra-yaoshi-ji',
    category: 'sutra',
    dynasty: 'tang',
    title: '藥師琉璃光如來本願功德經·藥師偈與讚',
    source: '唐·玄奘 譯',
    description: '讚歎藥師琉璃光如來本願功德的偈頌，祈請藥師佛拔除一切病苦，成就解脫。',
    content: '藥師如來琉璃光，燄網莊嚴無等倫。無邊行願利群倫，十二大願度眾生。藥師灌頂真言，宣說琉璃世界莊嚴，病苦悉除，身心安樂。稽首皈依藥師佛，願我速得智慧明，消災延壽，離苦得樂，普願眾生同證琉璃世界功德。',
  },

  {
    id: 'sutra-yaoshi-wishes',
    category: 'sutra',
    dynasty: 'tang',
    title: '藥師經·十二大願 (全文)',
    source: '唐·玄奘 譯',
    description: '藥師經中記述藥師琉璃光如來在因地修行時所發的十二大願中之前三大願，期盼眾生皆得琉璃之身。',
    content: '第一大願：願我來世得阿耨多羅三藐三菩提時，自身光明熾然，照曜無量無數無邊世界，以三十二大丈夫相、八十隨好，莊嚴其身；令一切有情，如我無異。第二大願：願我來世得菩提時，身如琉璃，內外明徹，淨無瑕穢；光明廣大，功德巍巍，身善安住，焰網莊嚴過於日月；幽冥眾生，悉蒙開曉，隨意所趣，作諸事業。第三大願：願我來世得菩提時，以無量無邊智慧方便，令諸有情皆得無盡所受用物，莫令眾生有所乏少。第四大願：願我來世得菩提時，若諸有情行邪道者，悉令安住菩提道中；若行聲聞、獨覺乘者，皆以大乘而安立之。第五大願：願我來世得菩提時，若有無量無邊有情，於我法中修行梵行，一切皆令得不缺戒，具三聚戒；設有毀犯，聞我名已，還得清淨，不墮惡趣。第六大願：願我來世得菩提時，若諸有情，其身下劣，諸根不具，醜陋、頑愚、盲、聾、瘖、瘂、攣躄、背僂、白癩、癲狂，種種病苦；聞我名已，一切皆得端正黠慧，諸根完具，無諸疾苦。第七大願：願我來世得菩提時，若諸有情，眾病逼切，無救無歸，無醫無藥，無親無家，貧窮多苦；我之名號，一經其耳，眾病悉除，身心安樂，家屬資具，悉皆豐足，乃至證得無上菩提。第八大願：願我來世得菩提時，若有女人，為女百惡之所逼惱，極生厭離，願捨女身；聞我名已，一切皆得轉女成男，具丈夫相，乃至證得無上菩提。第九大願：願我來世得菩提時，令諸有情，出魔罥網，解脫一切外道纏縛；若墮種種惡見稠林，皆當引攝置於正見，漸令修習諸菩薩行，速證無上正等菩提。第十大願：願我來世得菩提時，若諸有情，王法所加，縛錄鞭撻，繫閉牢獄，或當刑戮，及餘無量災難凌辱，悲愁煎逼，身心受苦；若聞我名，以我福德威神力故，皆得解脫一切憂苦。第十一大願：願我來世得菩提時，若諸有情，飢渴所惱，為求食故造諸惡業；得聞我名，專念受持，我當先以上妙飲食，飽足其身；後以法味，畢竟安樂而建立之。第十二大願：願我來世得菩提時，若諸有情，貧無衣服，蚊虻寒熱，晝夜逼惱；若聞我名，專念受持，如其所好，即得種種上妙衣服，亦得一切寶莊嚴具，華鬘、塗香，鼓樂眾伎，隨心所翫，皆令滿足。',
  },

  {
    id: 'sutra-yuanjue-puxian',
    category: 'sutra',
    dynasty: 'tang',
    title: '大方廣圓覺修多羅了義經·普賢菩薩章 (全文)',
    source: '唐·罽賓沙門佛陀多羅 譯',
    description: '圓覺經普賢菩薩章中極具禪宗頓悟色彩的無上妙法，「知幻即離，離幻即覺」。',
    content: '善男子，一切眾生種種幻化，皆生如來圓覺妙心，猶如空花從空而有，幻花雖滅空性不壞。眾生幻心還依幻滅，諸幻盡滅覺心不動。依幻說覺亦名為幻，若說有覺未離幻，說無覺者亦復如是。是故幻滅名為不動。善男子，一切菩薩及末世眾生，應當遠離一切幻化虛妄境界。由堅執持遠離心故，心如幻者亦復遠離。遠離為幻亦復遠離，離遠離幻亦復遠離。得無所離即除諸幻。譬如鑽火，兩木相因，火出木盡，灰飛煙滅。以幻修幻亦復如是，諸幻雖盡不入斷滅。善男子，知幻即離，不作方便；離幻即覺，亦無漸次。一切菩薩及末世眾生，依此修行，如是乃能永離諸幻。',
  },

  {
    id: 'sutra-fumu-shien',
    category: 'sutra',
    dynasty: 'tang',
    title: '佛說父母恩重難報經·十恩偈',
    source: '唐·阿地瞿多 譯',
    description: '講述父母對子女深重恩德的經典，以十首偈頌詳細列舉母親十月懷胎及育兒之艱辛與大恩。',
    content: '第一懷胎守護恩，第二臨產受苦恩，第三生子忘憂恩，第四咽苦吐甘恩，第五迴乾就濕恩，第六哺乳養育恩，第七洗濯不淨恩，第八遠行憶念恩，第九深加體恤恩，第十究竟憐愍恩。父母恩德深如海，為人子女須感恩，盡孝奉養莫遲延，敬順雙親第一尊。',
  },

  {
    id: 'sutra-lengyan-zhouxin',
    category: 'sutra',
    dynasty: 'tang',
    title: '大佛頂首楞嚴神咒·咒心',
    source: '唐·般剌密帝 譯',
    description: '楞嚴神咒的最後部分，即楞嚴咒心，為整個咒語之精髓，具有無量加持力。',
    content: '大佛頂首楞嚴神咒心。跢姪他。唵。阿那隸。毗舍提。鞞囉。跋闍囉。陀唎。盤陀盤陀你。跋闍囉·謗尼泮。虎合信都嚧甖泮。莎婆訶。願以此功德，消除一切災障，增長福慧，身心安泰，同登圓覺妙道。',
  },

  {
    id: 'sutra-ludumu-mantra',
    category: 'sutra',
    dynasty: 'tang',
    title: '綠度母心咒與讚頌',
    source: '藏傳佛教經典',
    description: '二十一度母之首綠度母的心咒與讚偈，祈請度母展現慈悲速度，救度八難眾生。',
    content: '綠度母心咒：嗡。答咧。都答咧。都咧。梭哈。度母大悲願力深，能除八難眾生苦，增延福慧得自在，隨心圓滿諸願求。稽首皈依綠度母，普願眾生離諸怖，安穩常處清淨國，速證無上菩提道。',
  },

  {
    id: 'sutra-sixwords-eulogy',
    category: 'sutra',
    dynasty: 'tang',
    title: '六字大明咒功德頌',
    source: '唐·天息災 譯',
    description: '觀世音菩薩微妙心印六字大明咒（唵嘛呢叭咪吽）的讚歌與功德述說。',
    content: '觀音菩薩心真言，六字大明普照天。唵嘛呢叭咪吽。此咒能閉六道門，能度六波羅蜜，清淨一切業障。若人持誦是真言，諸佛菩薩常隨護，消災免難福無量，早日圓成菩提果。',
  },

  {
    id: 'sutra-vajrasattva-100',
    category: 'sutra',
    dynasty: 'tang',
    title: '金剛薩埵百字明咒與祈請',
    source: '唐·不空 譯',
    description: '消業障第一法門之百字明咒的漢音及懺悔祈請文，極具淨化力量。',
    content: '金剛薩埵百字明真言：嗡。班雜薩埵薩瑪呀。嘛奴巴拉呀。班雜薩埵喋諾巴。地叉則卓美巴哇。素埵喀唷美巴哇。素波喀唷美巴哇。阿奴囉埵美巴哇。沙哇悉地美札呀札。沙哇嘎嘛素雜美。極當希利呀固嚕吽。哈哈哈哈霍。巴嘎哇那。沙哇達他嘎達。班雜嘛美姆雜。班札巴哇。嘛哈薩瑪呀。薩埵阿。願消除無始以來一切障礙，身口意悉皆清淨。',
  },

  {
    id: 'sutra-padmasambhava-7',
    category: 'sutra',
    dynasty: 'tang',
    title: '蓮師心咒與金剛七句祈請文',
    source: '藏傳佛教經典',
    description: '藏密祖師蓮花生大士之祈請文與心咒，祈請蓮師降臨加持消除一切魔障。',
    content: '金剛七句祈請文：鄔金剎土西北隅，蓮莖花胚之座上，稀有勝功德證，廣稱蓮花生大士，眾多空行眷圍繞，我今如法而修持，為作加持祈降臨。蓮花生大士心咒：嗡。阿。吽。班雜。咕嚕。貝瑪。悉地。吽。',
  },
  {
    id: 'sutra-daily-recitation-collection',
    category: 'sutra',
    dynasty: 'tang',
    title: '佛門日誦早晚課誦修持合卷',
    source: '大乘佛教課誦儀軌',
    description: '完整整併開經偈、大乘八句懺悔文、三皈依文、四無量心、六祖無相頌、普賢菩薩警眾偈、讚佛偈與大乘迴向偈，字數約 550 字，體現清淨圓滿的修持次第。',
    content: '【開經偈】\n無上甚深微妙法，百千萬劫難遭遇。我今見聞得受持，願解如來真實義。\n\n【大乘八句懺悔文】\n往昔所造諸惡業，皆由無始貪瞋癡，從身語意之所生，一切我今皆懺悔。罪從心起將心懺，心若滅時罪亦亡，心滅罪亡兩俱空，是則名為真懺悔。\n\n【三皈依文】\n自皈依佛，當願眾生，體解大道，發無上心。自皈依法，當願眾生，深入經藏，智慧如海。自皈依僧，當願眾生，統理大眾，一切無礙。和南聖眾。\n\n【四無量心】\n願諸眾生具足樂及樂因，是名慈無量。願諸眾生永離苦及苦因，是名悲無量。願諸眾生永具無苦之樂，是名喜無量。願諸眾生遠離愛憎住平等，是名捨無量。\n\n【六祖無相頌】\n心平何勞持戒，行直何用修禪。恩則孝養父母，義則上下相憐。讓則尊卑和睦，忍則眾惡無喧。改過必生智慧，護短心內非賢。菩提只向心覓，何勞向外求玄。\n\n【普賢警眾偈】\n是日已過，命亦隨減。如少水魚，斯有何樂。大眾當勤精進，如救頭然。但念無常，慎勿放逸。\n\n【讚佛偈與大迴向】\n阿彌陀佛身金色，相好光明無等倫。白毫宛轉五須彌，紺目澄清四大海。願以此功德，莊嚴佛淨土。上報四重恩，下濟三途苦。若有見聞者，悉發菩提心。盡此一報身，同生極樂國。',
  },

  {
    id: 'sutra-hanshan-poems',
    category: 'sutra',
    dynasty: 'tang',
    title: '寒山大士勸世詩 (選粹)',
    source: '唐·寒山',
    description: '唐代隱士寒山子所作的禪意勸世詩，通俗易懂，富含人生哲理。',
    content: '我見世間人，生生死死忙。不知身是幻，唯為利名狂。貪愛如枷鎖，瞋恚似火房。何如歸山野，閒坐看月光。碧澗清流急，青松白雲長。心中無一事，隨處是仙鄉。急急忙忙度日，回頭已是百年。何不早修心性，免受六道輪迴。',
  },

  {
    id: 'sutra-shide-patience',
    category: 'sutra',
    dynasty: 'tang',
    title: '拾得大士忍耐歌 (選粹)',
    source: '唐·拾得',
    description: '寒山與拾得著名的問答，講述世間的待人接物與慈悲忍辱之智慧。',
    content: '昔日寒山問拾得曰：世間有人謗我、欺我、辱我、笑我、輕我、賤我、惡我、騙我，如何處治乎。拾得曰：只要忍他、讓他、由他、避他、耐他、敬他、不要理他，再過幾年，你且看他。老拙穿衲襖，淡飯腹中飽。有人罵老拙，老拙只說好。有人打老拙，老拙自睡倒。唾在我面上，隨它自乾了。我也省力氣，他也無煩惱。這樣波羅蜜，便是妙寶。',
  },
  {
    id: 'classic-songdongshaonanxu',
    category: 'classic',
    dynasty: 'tang',
    title: '送董邵南序',
    source: '韓愈',
    description: '韓愈為落第士人董邵南撰寫的贈言，筆調委婉曲折，隱含同情與惜才之意。',
    content: '燕、趙古稱多感慨悲歌之士。董生舉進士，連不得志於有司，懷抱利器，鬱鬱適茲土。吾知其必有合也。董生勉乎哉！夫以子之不遇時，苟慕義彊仁者，皆愛惜焉，矧燕、趙之士出乎其性者哉！然吾嘗聞風俗與化移易，吾惡知其今不異於古所云耶？聊以吾子之行卜之也。董生勉乎哉！吾因子有所感矣。為我弔望諸君之墓，而觀於其市，復有昔時屠狗者乎？為我謝曰：「明天天子在上，可以出而仕矣。」',
  },
  {
    id: 'classic-zashuoyi',
    category: 'classic',
    dynasty: 'tang',
    title: '雜說一',
    source: '韓愈',
    description: '韓愈以「龍與雲」的關係為喻，闡明賢臣與明君相輔相成的道理。',
    content: '龍噓氣成雲，雲固弗靈於龍也。然龍乘是氣，茫洋窮乎玄間，薄日月，伏光景，感震電，神變化，水下土，汩陵谷，雲亦靈怪矣哉！雲，龍之所能使為靈也；若龍之靈，則非雲之所能使為靈也。然龍弗得雲，無以神其靈矣。失其所憑依，信不可歟！異哉！其所憑依，乃其所自為也。《易》曰：「雲從龍。」既曰龍，雲從之矣。',
  },
  {
    id: 'poem-shanshi',
    category: 'poem',
    dynasty: 'tang',
    title: '山石',
    source: '韓愈',
    description: '韓愈著名長篇敘事詩，描寫遊山寺之見聞與自然景色，筆力遒勁。',
    content: '山石犖确行徑微，黃昏到寺蝙蝠飛。升堂坐階新雨足，芭蕉葉大梔子肥。僧言古壁佛畫好，以火來照所見稀。鋪床拂席置羹飯，疏糲亦足飽我飢。夜深靜臥百蟲絕，清月出嶺光入扉。天明獨去無道路，出入高下窮煙霏。山紅澗碧紛爛漫，時見松櫪皆十圍。當流赤足踏澗石，水聲激激風吹衣。人生如此自可樂，豈必局束為人鞿？嗟哉吾黨二三子，安得至老不更歸！',
  },
  {
    id: 'poem-zuoqianzhilanguan',
    category: 'poem',
    dynasty: 'tang',
    title: '左遷至藍關示姪孫湘',
    source: '韓愈',
    description: '韓愈因諫迎佛骨被貶潮州，在途中所作之七律，慷慨悲涼。',
    content: '一封朝奏九重天，夕貶潮州路八千。欲為聖明除弊事，肯將衰朽惜殘年！雲橫秦嶺家何在？雪擁藍關馬不前。知汝遠來應有意，好收吾骨瘴江邊。',
  },
  {
    id: 'poem-tingyingshidianqin',
    category: 'poem',
    dynasty: 'tang',
    title: '聽穎師彈琴',
    source: '韓愈',
    description: '摹寫琴聲的高超詩作，將抽象的音樂描繪得具體生動。',
    content: '昵暱兒女語，恩怨相爾汝。劃然變軒昂，勇士赴敵場。浮雲柳絮無根蒂，天地闊遠隨飛揚。喧啾百鳥群，忽見孤鳳凰。躋攀分寸不可上，失勢一落千丈強。嗟余有兩耳，未省聽絲篁。自聞穎師彈，起坐在一旁。推手遽止之，溼衣淚滂滂。穎乎爾誠能，無以冰炭置我腸！',
  },
  {
    id: 'classic-jieyuwen',
    category: 'classic',
    dynasty: 'tang',
    title: '祭鱷魚文',
    source: '韓愈',
    description: '韓愈任潮州刺史時所作，展現其治民決心與不畏強梁的氣魄。',
    content: '維年月日，潮州刺史韓愈，使軍事衙推秦濟，以羊一、豬一，投惡谿之潭水，以與鱷魚食，而告之曰：昔先王既有天下，烈山澤，罔繩擉刃，以除蟲蛇惡物為民害者，驅而出之四海之外。及後王德薄，不能遠有，則江、漢之間，尚皆棄之，以與蠻、夷、楚、越，況潮、嶺海之間，去京師萬里哉！鱷魚之涵淹卵育於此，亦固其所。今天子嗣唐位，神聖慈武，四海之外，六合之內，皆撫而有之；況禹跡所揜，揚州之近地，刺史、縣令之所治，出貢賦以供天地、宗廟、百神之祀之壤者哉？鱷魚其不可與刺史雜處此土也。刺史受天子命，守此土，治此民，而鱷魚睅然不安谿潭，據處食民畜、熊、豕、鹿、獐，以肥其身，以種其子孫；與刺史亢拒，爭為長雄。刺史雖駑弱，亦安肯為鱷魚低首下心，伈伈睍睍，為民吏羞，以偷活於此邪！且承天子命以來為吏，固其勢不得不與鱷魚辨。鱷魚有知，其聽刺史言：潮之州，大海在其南，鯨、鵬之大，蝦、蟹之細，無不歸容，以生以食，鱷魚朝發而夕至也。今與鱷魚約：盡三日，其率醜類南徙於海，以避天子之命吏；三日不能，至五日；五日不能，至七日；七日不能，是終不肯徙也。是不有刺史、聽從其言也；不然，則是鱷魚冥頑不靈，刺史雖有言，不聞不知也。夫傲天子之命吏，不聽其言，不徙以避之，與冥頑不靈而為民物害者，皆可殺。刺史則選材技吏民，操強弓毒矢，以與鱷魚從事，必盡殺乃止。其無悔！',
  },
  {
    id: 'classic-boyisong',
    category: 'classic',
    dynasty: 'tang',
    title: '伯夷頌',
    source: '韓愈',
    description: '韓愈讚頌伯夷、叔齊特立獨行、信道篤守的崇高志節。',
    content: '士之特立獨行，適於義而已。不顧人之是非，皆豪傑之士，信道篤而自知明者也。一家非之，力行而不惑者，寡矣；至於一國一州非之，力行而不惑者，蓋天下一人而已矣；若至於舉世非之，力行而不惑者，則千百年乃一人而已耳。若伯夷者，窮天地、亙萬世而不顧者也。昭乎日月不足為明，崒乎泰山不足為高，巍乎天地不足為容也！當殷之亡、周之興，微子賢也，抱祭器而去之；武王、周公，聖也，從天下之賢士，與天下之諸侯，而往攻之，未嘗聞有非之者也。彼伯夷、叔齊者，乃獨以為不可。殷既滅矣，天下宗周，彼二子乃獨恥食其粟，餓死而不顧。繇是而言，夫豈有求而為哉？信道篤而自知明也。今世之所謂士者，一凡人譽之，則自以為有餘；一凡人沮之，則自以為不足。彼獨非聖人，而自是如此。夫聖人，乃萬世之標準也。余故曰：若伯夷者，特立獨行，窮天地、亙萬世而不顧者也。雖然，微二子，亂臣賊子接跡於後世矣。',
  },
  {
    id: 'poem-fudushuchengnan',
    category: 'poem',
    dynasty: 'tang',
    title: '符讀書城南',
    source: '韓愈',
    description: '韓愈寫給兒子韓符的勸學詩，語重心長，名句「三十骨骼成，乃一龍一豬」。',
    content: '木之就規矩，在梓匠輪輿。人之能為人，由腹有詩書。詩書勤乃有，不勤腹空虛。欲知學之力，賢愚同一初。由其不能學，所入遂異閭。兩家各生子，提孩巧相如。少長聚嬉戲，不殊同隊魚。年至十二三，頭角稍相疏。二十漸乖張，清溝映汙渠。三十骨骼成，乃一龍一豬。飛黃騰踏去，不能顧蟾蜍。一為馬前卒，鞭背生蟲蛆。一為公與相，潭潭府中居。問之何因爾，學與不學歟。金璧雖重寶，費用難貯儲。學問藏之身，身在則有餘。君子與小人，不繫父母且。不見公與相，起身自犂鉏。不見三公後，寒飢出無驢。文章豈不貴，經訓乃菑畬。潢潦無根源，朝滿夕已除。人不通古今，馬牛而襟裾。行身陷不義，況望多名譽。時秋積雨霽，新涼入郊墟。燈火稍可親，簡編可卷舒。豈不旦夕念，為爾惜居諸。恩義有相奪，作詩勸躊躇。',
  },
  {
    id: 'classic-zashuoer',
    category: 'classic',
    dynasty: 'tang',
    title: '雜說二',
    source: '韓愈',
    description: '韓愈借醫者治病之理，論述國家綱紀政令的重要性。',
    content: '善醫者，不視人之瘠肥，察其脈之病否而已矣；善計天下者，不視天下之安危，察其紀綱之理亂而已矣。天下者，人也；安危者，肥瘠也；紀綱者，脈也。脈不病，雖瘠不害；脈病而肥者，死矣。通於此說者，其知所以為天下乎！夏、殷、周之衰也，諸侯作而戰伐日行矣。傳數十王而天下不傾者，紀綱存焉耳。秦之王天下也，無分勢於諸侯，聚兵而焚之，傳二世而天下傾者，紀綱亡焉耳。是故四支雖無故，不足恃也，脈而已矣；四海雖無事，不足矜也，紀綱而已矣。憂其所可恃，懼其所可矜，善醫善計者，謂之天扶與之。《易》曰：「視履考祥。」善醫善計者為之。',
  },
  {
    id: 'classic-zashuosan',
    category: 'classic',
    dynasty: 'tang',
    title: '雜說三',
    source: '韓愈',
    description: '韓愈借崔山君傳，感嘆世人不盡其性、與禽獸無異。',
    content: '談生之為《崔山君傳》，稱鶴言者，豈不怪哉！然吾觀於人，其能盡其性而不類於禽獸異物者希矣，將憤世嫉邪長往而不來者之所為乎？昔之聖者，其首有若牛者，其形有若蛇者，其喙有若鳥者，其貌有若蒙倛者，彼皆貌似而心不同焉，可謂之非人邪？即有平肋曼膚，顏如渥丹，美而很者，貌則人，其心則禽獸，又惡可謂之人邪？然則觀貌之是非，不若論其心與其行事之可否為不失也。怪神之事，孔子之徒不言，余將特取其憤世嫉邪而作之，故題之雲爾。',
  },
  {
    id: 'classic-xiaoshitanji',
    category: 'classic',
    dynasty: 'tang',
    title: '小石潭記',
    source: '柳宗元',
    description: '永州八記代表作，描寫小石潭的清冽幽邃與作者孤寂的心境。',
    content: '從小丘西行百二十步，隔篁竹，聞水聲，如鳴珮環，心樂之。伐竹取道，下見小潭，水尤清冽。全石以為底，近岸，卷石底以出，為坻，為嶼，為嵁，為巖。青樹翠蔓，蒙絡搖綴，參差披拂。潭中魚可百許頭，皆若空游無所依。日光下澈，影布石上，佁然不動；俶爾遠逝，往來翕忽，似與游者相樂。潭西南而望，斗折蛇行，明滅可見。其岸勢犬牙差互，不可知其源。坐潭上，四面竹樹環合，寂寥無人，淒神寒骨，悄愴幽邃。以其境過清，不可久居，乃記之而去。同游者：吳武陵，龔古，余弟宗玄。隸而從者，崔氏二小生：曰恕己，曰奉壹。',
  },
  {
    id: 'classic-gumutanji',
    category: 'classic',
    dynasty: 'tang',
    title: '鈷鉧潭記',
    source: '柳宗元',
    description: '永州八記之二，寫發現與買下鈷鉧潭的經過，寄託身世之感。',
    content: '鈷鉧潭在西山西，其始蓋冉水自南奔注，抵山石，屈折東流，其顛委勢峻，盪擊益暴，齧其涯，故旁廣而中深，畢至石乃止。流沫成輪，然後徐行，其清而平者且十畝餘，有樹環焉，有泉懸焉。其上有居者，以予之亟遊也，一旦款門來告曰：「不勝官租私券之委積，既芟山而更居，願以潭上田貿財以緩禍。」予樂而如其言。則崇其台，延其檻，行其泉於高者而墜之潭，有聲潀然。尤與中秋觀月為宜，於以見天之高，氣之迥。孰使予樂居夷而忘故土者，非茲潭也歟？',
  },
  {
    id: 'classic-gumutanxixiaoqiuji',
    category: 'classic',
    dynasty: 'tang',
    title: '鈷鉧潭西小丘記',
    source: '柳宗元',
    description: '永州八記之三，記錄開墾小丘、顯露奇石美竹的樂趣與感悟。',
    content: '得西山後八日，尋山口西北道二百步，又得鈷鉧潭。西二十五步，當湍而浚者為魚梁。梁之上有丘焉，生竹樹。其石之突怒偃蹇，負土而出，爭為奇狀者，殆不可數：其嶔然相累而下者，若牛馬之飲於溪；其衝然角列而上者，若熊羆之登於山。丘之小不能一畝，可以籠而有之。問其主，曰：「唐氏之棄地，貨而不售。」問其價，曰：「止四百。」予憐而售之。李深源、元克己時同遊，皆大喜，出自意外。即更取器用，剷刈穢草，伐去惡木，烈火而焚之。嘉木立，美竹露，奇石顯。由其中以望，則山之高，雲之浮，溪之流，鳥獸之遨遊，舉熙熙然回巧獻技，以效茲丘之下。枕席而臥，則清泠之狀與目謀，瀯瀯之聲與耳謀，悠然而虛者與神謀，淵然而靜者與心謀。不匝旬而得異地者二，雖古好事之士，或未能至焉。噫！以茲丘之勝，致之灃、鎬、鄠、杜，則貴遊之士爭買者，日增千金而愈不可得。今棄是州也，農夫漁父，過而陋之，價四百，連歲不能售。而我與深源、克己獨喜得之，是其果有遭乎？書於石，所以賀茲丘之遭也。',
  },
  {
    id: 'classic-yuanjiakeji',
    category: 'classic',
    dynasty: 'tang',
    title: '袁家渴記',
    source: '柳宗元',
    description: '永州八記之五，描繪袁家渴奇特的水石景緻與豐富的植物。',
    content: '由冉溪西南水行十里，山水之可取者五，莫若鈷鉧潭。由溪口而西陸行，可取者八九，莫若西山。由朝陽岩東南水行至蕪江，可取者三，莫若袁家渴。皆永中幽麗處也。楚越之間方言，謂水之反流者為「渴」。渴上與南館高嶂合，下與百家瀨合。其中重洲小溪，澄潭淺渚，間廁曲折，平者深黑，峻者沸白。舟行若窮，忽又無際。有小山出水中，山皆美石，上生青叢，冬夏常蔚然。其旁多岩洞，其下多白礫，其樹多楓楠石楠楩櫧樟柚，草則蘭芷。又有異卉，類合歡而蔓生，轇轕水石。每風自四山而下，振動大木，掩苒眾草，紛紅駭綠，蓊葧香氣，衝濤旋瀨，退貯溪谷，搖揚葳蕤，與時推移。其大都如此，余無以窮其狀。永之人未嘗遊焉，予得之，不敢專也，出而傳於世。其地世主袁氏，故以名焉。',
  },
  {
    id: 'classic-shiquji',
    category: 'classic',
    dynasty: 'tang',
    title: '石渠記',
    source: '柳宗元',
    description: '永州八記之六，記錄開鑿疏導石渠、窮盡其奇美水石的樂趣。',
    content: '自渴西南行，不能百步，得石渠，民橋其上。有泉幽幽然，其鳴乍大乍細。渠之廣或咫尺或倍尺，其長可十許步。其流抵大石，伏出其下。逾石而往，有石泓，昌蒲被之，青蘚環周。又折西行，旁陷岩石下，北墮小潭。潭幅員減百尺，清深多鯈魚。又北曲行紆餘，睨若無窮，然卒入於渴。其側皆詭石怪木，奇卉美箭，可列坐而休焉。風搖其巔，韻動崖谷。視之既靜，其聽始遠。予從州牧得之，攬去翳朽，決疏土石，既崇而焚，既釃而盈。惜其未始有傳焉者，故累記其所屬，遺之其人，書之其陽，俾後好事者求之得以易。元和七年正月八日，蠲渠至大石。十月十九日，逾石得石泓小潭。渠之美於是始窮也。',
  },
  {
    id: 'classic-shijianji',
    category: 'classic',
    dynasty: 'tang',
    title: '石澗記',
    source: '柳宗元',
    description: '永州八記之七，描繪石澗交錯流動、觸石激發的優美音響。',
    content: '石渠之事既窮，上由橋西北，下土山之陰，民又橋焉。其水之大，倍石渠三之一。亙石為底，達於兩涯。若床若堂，若陳筵席，若限閫奧。水平布其上，流若織文，響若操琴。揭跣而往，折竹掃陳葉，排腐木，可羅胡床十八九居之。交絡之流，觸激之音，皆在牀下；翠羽之木，龍鱗之石，均蔭其上。古之人其有樂乎此耶？後之來者有能追予之踐履耶？得意之日，與石渠同。由渴而來者，先石渠，後石澗；由百家瀨上而來者，先石澗，後石渠。澗之可窮者，皆出石城村東南，其間可樂者數焉。',
  },
  {
    id: 'classic-xiaoshichengshanji',
    category: 'classic',
    dynasty: 'tang',
    title: '小石城山記',
    source: '柳宗元',
    description: '永州八記之尾，藉由奇石險遠，感嘆人才埋沒於偏遠荒土。',
    content: '自西山道口徑北，逾黃茅嶺而下，有二道：其一西出，尋之無所得；其一少北而東，不過四十丈，土斷而川分，有積石橫當其垠。其上為睥睨梁欐之形，其旁出堡塢，有若門焉。窺之正黑，投以小石，洞然有水聲，其響之激越，良久乃已。環之可上，望甚遠，無土壤，而生嘉樹美箭，益奇而堅，其疏數偃仰，類智者所施設也。噫！吾疑造物者之有無久矣。及是愈以為誠有。又怪其不為之中州，而列是夷狄，更千百年不得一售其伎，是固勞而無用，神者儻不宜如是，則其果無乎？或曰：「以慰夫賢而辱於此者。」或曰：「其氣之靈不為偉人，而獨為是物，故楚之南少人而多石。」是二者，予未信之。',
  },
  {
    id: 'classic-qianzhilv',
    category: 'classic',
    dynasty: 'tang',
    title: '黔之驢',
    source: '柳宗元',
    description: '柳宗元著名寓言故事，比喻徒有其表、毫無實才者的悲劇下場。',
    content: '黔無驢，有好事者船載以入。至則無可用，放之山下。虎見之，龐然大物也，以為神，蔽林間窺之。稍出近之，慭慭然，莫相知。他日，驢一鳴，虎大駭，遠遁；以為且噬己也，甚恐。然往來視之，覺無異能者；益習其聲，又近出前後，終不敢搏。稍近，益狎，蕩倚衝冒。驢不勝怒，蹄之。虎因喜，計之曰：「技止此耳！」因跳踉大㘎，斷其喉，盡其肉，乃去。噫！形之龐也類有德，聲之宏也類有能。向不出其技，虎雖猛，疑畏，卒不敢取。今若是焉，悲夫！',
  },
  {
    id: 'classic-zirenzhuan',
    category: 'classic',
    dynasty: 'tang',
    title: '梓人傳',
    source: '柳宗元',
    description: '藉由梓人善於運籌指揮而不事小勞，論說天子宰相的治國之道。',
    content: '裴封叔之第，在光德里。有梓人款其門，願傭隙宇而處焉。所職尋、引、規、矩、繩、墨，家不居礱斫之器。問其能，曰：「吾善度材，視棟宇之制，高深、圓方、短長之宜，吾指使而群工役焉。舍我，眾莫能就一宇。故食於官府，吾受祿三倍；作於私家，吾收其直太半焉。」他日，入其室，其床闕足而不能理，曰：「將求他工。」余甚笑之，謂其無能而貪祿嗜貨者。其後京兆尹將飾官署，余往過焉。委群材，會群工，或執斧斤，或執刀鋸，皆環立向之。梓人左持引，右執杖，而中處焉。量棟宇之任，視木之能，舉揮其杖曰：「斧！」彼執斧者奔而右；顧而指曰：「鋸！」彼執鋸者趨而左。俄而，斤者斫，刀者削，皆視其色，俟其言，莫敢自斷者。其不勝任者，怒而退之，亦莫敢慍焉。畫宮於堵，盈尺而曲盡其制，計其毫釐而構大廈，無進退焉。既成，書於上棟曰：「某年某月某日某建」，則其姓字也。凡執用之工不在列。余圜視大駭，然後知其術之工大矣。繼而歎曰：彼將舍其手藝，專其心智，而能知體要者歟！吾聞勞心者役人，勞力者役於人，彼其勞心者歟？能者用而智者謀，彼其智者歟？是足為佐天子、相天下法矣！物莫近乎此也。彼為天下者，本於人。其執役者，為徒隸，為鄉師、里胥；其上為下士；又其上為中士，為上士；又其上為大夫，為卿，為公。離而為六職，判而為百役。外薄四海，有方伯、連率。郡有守，邑有宰，皆有佐政。其下有胥吏，又其下皆有嗇夫、版尹，以就役焉，猶眾工之各有執伎以食力也。彼佐天子、相天下者，舉而加焉，指而使焉，條其綱紀而盈縮焉，齊其法制而整頓焉，猶梓人之有規矩、繩墨以定制也。擇天下之士，使稱其職；居天下之人，使安其業。視都知野，視野知國，視國知天下，其遠邇細大，可手據其圖而究焉，猶梓人畫宮於堵而績於成也。能者進而由之，使無所德；不能者退而休之，亦莫敢慍。不衒能，不矜名，不親小勞，不侵眾官，日與天下之英才討論其大經，猶梓人之善運眾工而不伐藝也。夫然後相道得而萬國理矣。相道既得，萬國既理，天下舉首而望曰：「吾相之功也。」後之人循跡而慕曰：「彼相之才也。」士或談殷、周之理者，曰伊、傅、周、召，其百執事之勞勤而不得紀焉，猶梓人自名其功而執用者不列也。大哉相乎！通是道者，所謂相而已矣。其不知體要者反此：以恪勤為公，以簿書為尊，衒能矜名，親小勞，侵眾官，竊取六職百役之事，聽聽於府庭，而遺其大者遠者焉，所謂不通是道者也。猶梓人而不知繩墨之曲直、規矩之方圓、尋引之短長，姑奪眾工之斧斤刀鋸以佐其藝，又不能備其工，以至敗績，用而無所成也。不亦謬歟！',
  },
  {
    id: 'classic-tongyefengdibian',
    category: 'classic',
    dynasty: 'tang',
    title: '桐葉封弟辨',
    source: '柳宗元',
    description: '柳宗元論析周成王桐葉封弟的史事，強調君王之政在於得當與行義，而非戲言必行。',
    content: '古之傳者有言：成王以桐葉與小弱弟戲，曰：「以封汝。」周公入賀。王曰：「戲也。」周公曰：「天子不可戲。」乃封小弱弟於唐。吾意不然。王之弟當封邪，周公宜以時言於王，不待其戲而賀以成之也。不當封邪，周公乃成其不中之戲，以地以人與小弱者為之主，其得為聖乎？且周公以王之言不可苟焉而已，必從而成之邪？設有不幸，王以桐葉戲婦寺，亦將舉而從之乎？凡王者之德，在行之何若。設未得其當，雖十易之不為病；要於其當，不可使易也，而況以其戲乎！若戲而必行之，是周公教王遂過也。吾意周公輔成王，宜以道，從容優樂，要歸之大中而已，必不逢其失而為之辭。又不當束縛之，馳驟之，使若牛馬然，急則敗矣。且家人父子尚不能以此自克，況號為君臣者邪！是直小丈夫缺缺者之事，非周公所宜用，故不可信。或曰：「封唐叔，史佚成之。」',
  },

  {
    id: 'poem-tang-dengguanquelou',
    category: 'poem',
    dynasty: 'tang',
    title: '登鸛雀樓',
    source: '王之渙',
    description: '「台灣國小」學段常見古典絕句，王之渙描繪黃河壯闊與高瞻遠矚的千古名篇。',
    content: '白日依山盡，黃河入海流。欲窮千里目，更上一層樓。',
  },
  {
    id: 'poem-tang-xunyinzhe',
    category: 'poem',
    dynasty: 'tang',
    title: '尋隱者不遇',
    source: '賈島',
    description: '「台灣國小」學段必學絕句，賈島尋訪隱者未遇的雋永小詩。',
    content: '松下問童子，言師採藥去。只在此山中，雲深不知處。',
  },
  {
    id: 'poem-tang-minnong',
    category: 'poem',
    dynasty: 'tang',
    title: '憫農詩·其二',
    source: '李紳',
    description: '「台灣國小」學段常用教材，李紳描繪農夫辛勞、勸戒珍惜糧食的名作。',
    content: '鋤禾日當午，汗滴禾下土。誰知盤中餐，粒粒皆辛苦。',
  },
  {
    id: 'poem-tang-yunge',
    category: 'poem',
    dynasty: 'tang',
    title: '詠鵝',
    source: '駱賓王',
    description: '「台灣國小」學段啟蒙童詩，駱賓王七歲時所作，生動描繪白鵝戲水姿態。',
    content: '鵝、鵝、鵝，曲項向天歌。白毛浮綠水，紅掌撥清波。',
  },
  {
    id: 'poem-tang-huixiangoushu',
    category: 'poem',
    dynasty: 'tang',
    title: '回鄉偶書',
    source: '賀知章',
    description: '「台灣國小」學段必備絕句，賀知章晚年回鄉的感懷之作。',
    content: '少小離家老大回，鄉音無改鬢毛衰。兒童相見不相識，笑問客從何處來。',
  },
  {
    id: 'poem-tang-jiangpandubu',
    category: 'poem',
    dynasty: 'tang',
    title: '江畔獨步尋花',
    source: '杜甫',
    description: '「台灣國小」學段常用教材，杜甫描寫春天繁花盛開與蜂蝶戲水景象的名篇。',
    content: '黃四娘家花滿蹊，千朵萬朵壓枝低。留連戲蝶時時舞，自在嬌鶯恰恰啼。',
  },
  {
    id: 'poem-tang-jiangnanchun',
    category: 'poem',
    dynasty: 'tang',
    title: '江南春',
    source: '杜牧',
    description: '「台灣國小」學段經典，杜牧描繪江南春景之廣闊與煙雨朦朧的千古名篇。',
    content: '千里鶯啼綠映紅，水村山郭酒旗風。南朝四百八十寺，多少樓台煙雨中。',
  },
  {
    id: 'poem-tang-ciwuyeti',
    category: 'poem',
    dynasty: 'tang',
    title: '慈烏夜啼',
    source: '白居易',
    description: '「台灣國中」學段必讀經典古詩，白居易借慈烏反哺諷喻世人應盡孝道。',
    content: '慈烏失其母，啞啞吐哀音。晝夜不飛去，經年守故林。夜夜夜半啼，聞者為沾襟。聲中如告訴，未盡反哺心。百鳥豈無母，爾獨哀怨深？應是母慈重，使爾悲不任。昔有吳起者，母歿喪不臨。嗟哉斯徒輩，其心若禽獸。慈烏復慈烏，鳥中之曾參。',
  },
  {
    id: 'poem-tang-dengyouzhoutai',
    category: 'poem',
    dynasty: 'tang',
    title: '登幽州台歌',
    source: '陳子昂',
    description: '「台灣國中」學段經典古詩，陳子昂感嘆生不逢時與宇宙孤獨的千古絕唱。',
    content: '前不見古人，後不見來者。念天地之悠悠，獨愴然而涕下！',
  },
  {
    id: 'poem-tang-huanghelou-cuihao',
    category: 'poem',
    dynasty: 'tang',
    title: '黃鶴樓',
    source: '崔顥',
    description: '「台灣國中」學段必備律詩，崔顥登黃鶴樓懷古思鄉，被譽為唐人七律第一。',
    content: '昔人已乘黃鶴去，此地空餘黃鶴樓。黃鶴一去不復返，白雲千載空悠悠。晴川歷歷漢陽樹，芳草萋萋鸚鵡洲。日暮鄉關何處是？煙波江上使人愁。',
  },
  {
    id: 'poem-tang-wenwangchangling',
    category: 'poem',
    dynasty: 'tang',
    title: '聞王昌齡左遷龍標遙有此寄',
    source: '李白',
    description: '「台灣國中」學段經典，李白借明月寄託對好友王昌齡貶謫之同情與深情。',
    content: '楊花落盡子規啼，聞道龍標過五溪。我寄愁心與明月，隨君直到夜郎西。',
  },
  {
    id: 'poem-tang-yugezi',
    category: 'poem',
    dynasty: 'tang',
    title: '漁歌子',
    source: '張志和',
    description: '「台灣國中」學段經典詞牌小令，張志和描繪江南春汛與漁翁超脫之景。',
    content: '西塞山前白鷺飛，桃花流水鱖魚肥。青箬笠，綠蓑衣，斜風細雨不須歸。',
  },
  {
    id: 'poem-tang-qiuxingyishou',
    category: 'poem',
    dynasty: 'tang',
    title: '秋興八首·其一',
    source: '杜甫',
    description: '「台灣高中」學段經典七律，杜甫晚年寓居夔州所作，寄託深沉的憂國思鄉之情。',
    content: '玉露凋傷楓樹林，巫山巫峽氣蕭森。江間波浪兼天湧，塞上風雲接地陰。叢菊兩開他日淚，孤舟一繫故園心。寒衣處處催刀尺，白帝城高急暮砧。',
  },
  {
    id: 'classic-jianyingfogubiao',
    category: 'classic',
    dynasty: 'tang',
    title: '諫迎佛骨表',
    source: '韓愈',
    description: '韓愈直言敢諫之代表奏疏，痛陳崇佛之弊，展現儒者氣節。',
    content: '臣某言：伏以佛者，夷狄之一法耳，自後漢時始入中國，古者未嘗有也。昔者黃帝在位百年，年百一十歲；少昊在位八十年，年百歲；磚頊在位七十八年，年九十八歲；帝嘿在位七十年，年百歲；帝堯在位九十八年，年百一十八歲；帝舜在位五十載，年百一十歲。此等之時，天下太平，百姓安樂壽考，然而中國未有佛也。禹在位二十六年，年百歲；湯在位二十九年，年百歲；文王在位五十年，年九十七歲；武王在位五十四年，年九十三歲；穆王在位五十年，年百四歲。此等之時，佛法亦未入中國，非因事佛而得此壽考也。漢明帝時始有佛法，明帝在位才十八年耳。其後亂亡相繼，運祚不長。宋、齊、梁、陳、元魏已下，事佛漸謹，年代尤促。唯梁武帝在位四十八年，前後三捨身施佛，宗廟之祭不牲犢，日一食，菜果茶飯，後竟為侯景所逼，餓死臺城，國亦尋滅。事佛求福，乃得更禍。由此觀之，佛不足信，亦可知矣。',
  },
  {
    id: 'classic-tang-hanyu-yuandao',
    category: 'classic',
    dynasty: 'tang',
    title: '原道',
    source: '韓愈',
    description: '《古文觀止》收錄之經典名篇，作者為韓愈。',
    content: '博愛之謂仁，行而宜之之謂義，由是而之焉之謂道，足乎己無待於外之謂德。仁與義爲定名，道與德爲虛位。故道有君子小人，而德有兇有吉。老子之小仁義，非毀之也，其見者小也。坐井而觀天，曰天小者，非天小也。彼以煦煦爲仁，孑孑爲義，其小之也則宜。其所謂道，道其所道，非吾所謂道也。其所謂德，德其所德，非吾所謂德也。凡吾所謂道德雲者，合仁與義言之也，天下之公言也。老子之所謂道德雲者，去仁與義言之也，一人之私言也。\n周道衰，孔子沒，火於秦，黃老於漢，佛於晉、魏、樑、隋之間。其言道德仁義者，不入於楊，則歸於墨；不入於老，則歸於佛。入於彼，必出於此。入者主之，出者奴之；入者附之，出者污之。噫！後之人其欲聞仁義道德之說，孰從而聽之？老者曰：“孔子，吾師之弟子也。”佛者曰：“孔子，吾師之弟子也。”爲孔子者，習聞其說，樂其誕而自小也，亦曰“吾師亦嘗師之”雲爾。不惟舉之於口，而又筆之於其書。噫！後之人雖欲聞仁義道德之說，其孰從而求之？\n甚矣，人之好怪也，不求其端，不訊其末，惟怪之慾聞。古之爲民者四，今之爲民者六。古之教者處其一，今之教者處其三。農之家一，而食粟之家六。工之家一，而用器之家六。賈之家一，而資焉之家六。奈之何民不窮且盜也？\n古之時，人之害多矣。有聖人者立，然後教之以相生相養之道。爲之君，爲之師。驅其蟲蛇禽獸，而處之中土。寒然後爲之衣，飢然後爲之食。木處而顛，土處而病也，然後爲之宮室。爲之工以贍其器用，爲之賈以通其有無，爲之醫藥以濟其夭死，爲之葬埋祭祀以長其恩愛，爲之禮以次其先後，爲之樂以宣其湮鬱，爲之政以率其怠倦，爲之刑以鋤其強梗。相欺也，爲之符、璽、鬥斛、權衡以信之。相奪也，爲之城郭甲兵以守之。害至而爲之備，患生而爲之防。今其言曰：“聖人不死，大盜不止。剖鬥折衡，而民不爭。”嗚呼！其亦不思而已矣。如古之無聖人，人之類滅久矣。何也？無羽毛鱗介以居寒熱也，無爪牙以爭食也。\n是故君者，出令者也；臣者，行君之令而致之民者也；民者，出粟米麻絲，作器皿，通貨財，以事其上者也。君不出令，則失其所以爲君；臣不行君之令而致之民，則失其所以爲臣；民不出粟米麻絲，作器皿，通貨財，以事其上，則誅。今其法曰，必棄而君臣，去而父子，禁而相生相養之道，以求其所謂清淨寂滅者。嗚呼！其亦幸而出於三代之後，不見黜於禹、湯、文、武、周公、孔子也。其亦不幸而不出於三代之前，不見正於禹、湯、文、武、周公、孔子也。\n帝之與王，其號雖殊，其所以爲聖一也。夏葛而冬裘，渴飲而飢食，其事雖殊，其所以爲智一也。今其言曰：“曷不爲太古之無事”？”是亦責冬之裘者曰：“曷不爲葛之之易也？”責飢之食者曰：“曷不爲飲之之易也？”傳曰：“古之慾明明德於天下者，先治其國；欲治其國者，先齊其家；欲齊其家者，先修其身；欲修其身者，先正其心；欲正其心者，先誠其意。”然則古之所謂正心而誠意者，將以有爲也。今也欲治其心而外天下國家，滅其天常，子焉而不父其父，臣焉而不君其君，民焉而不事其事。孔子之作《春秋》也，諸侯用夷禮則夷之，進於中國則中國之。經曰：“夷狄之有君，不如諸夏之亡。”《詩》曰：戎狄是膺，荊舒是懲”今也舉夷狄之法，而加之先王之教之上，幾何其不胥而爲夷也？\n夫所謂先王之教者，何也？博愛之謂仁，行而宜之之謂義。由是而之焉之謂道。足乎己無待於外之謂德。其文：《詩》、《書》、《易》、《春秋》；其法：禮、樂、刑、政；其民：士、農、工、賈；其位：君臣、父子、師友、賓主、昆弟、夫婦；其服：麻、絲；其居：宮、室；其食：粟米、果蔬、魚肉。其爲道易明，而其爲教易行也。是故以之爲己，則順而祥；以之爲人，則愛而公；以之爲心，則和而平；以之爲天下國家，無所處而不當。是故生則得其情，死則盡其常。效焉而天神假，廟焉而人鬼饗。曰：“斯道也，何道也？”曰：“斯吾所謂道也，非向所謂老與佛之道也。堯以是傳之舜，舜以是傳之禹，禹以是傳之湯，湯以是傳之文、武、周公，文、武、周公傳之孔子，孔子傳之孟軻，軻之死，不得其傳焉。荀與揚也，擇焉而不精，語焉而不詳。由周公而上，上而爲君，故其事行。由周公而下，下而爲臣，故其說長。然則如之何而可也？曰：“不塞不流，不止不行。人其人，火其書，廬其居。明先王之道以道之，鰥寡孤獨廢疾者有養也。其亦庶乎其可也！”',
  },
  {
    id: 'classic-tang-lihua-diaoguzhanchangwen',
    category: 'classic',
    dynasty: 'tang',
    title: '弔古戰場文',
    source: '李華',
    description: '《古文觀止》收錄之經典名篇，作者為李華。',
    content: '浩浩乎，平沙無垠，夐不見人。河水縈帶，羣山糾紛。黯兮慘悴，風悲日曛。蓬斷草枯，凜若霜晨。鳥飛不下，獸鋌亡羣。亭長告餘曰：“此古戰場也，常覆三軍。往往鬼哭，天陰則聞。”傷心哉！秦歟漢歟？將近代歟？\n吾聞夫齊魏徭戍，荊韓召募。萬裏奔走，連年暴露。沙草晨牧，河冰夜渡。地闊天長，不知歸路。寄身鋒刃，腷臆誰愬？秦漢而還，多事四夷，中州耗斁，無世無之。古稱戎夏，不抗王師。文教失宣，武臣用奇。奇兵有異於仁義，王道迂闊而莫爲。嗚呼噫嘻！\n吾想夫北風振漠，胡兵伺便。主將驕敵，期門受戰。野豎旌旗，川回組練。法重心駭，威尊命賤。利鏃穿骨，驚沙入面，主客相搏，山川震眩。聲析江河，勢崩雷電。至若窮陰凝閉，凜冽海隅，積雪沒脛，堅冰在須。鷙鳥休巢，徵馬踟躕。繒纊無溫，墮指裂膚。當此苦寒，天假強胡，憑陵殺氣，以相剪屠。徑截輜重，橫攻士卒。都尉新降，將軍覆沒。屍踣巨港之岸，血滿長城之窟。無貴無賤，同爲枯骨。可勝言哉！鼓衰兮力竭，矢盡兮弦絕，白刃交兮寶刀折，兩軍蹙兮生死決。降矣哉，終身夷狄；戰矣哉，暴骨沙礫。鳥無聲兮山寂寂，夜正長兮風淅淅。魂魄結兮天沉沉，鬼神聚兮雲冪冪。日光寒兮草短，月色苦兮霜白。傷心慘目，有如是耶！\n吾聞之：牧用趙卒，大破林胡，開地千里，遁逃匈奴。漢傾天下，財殫力痡。任人而已，豈在多乎！周逐獫狁，北至太原。既城朔方，全師而還。飲至策勳，和樂且閒。穆穆棣棣，君臣之間。秦起長城，竟海爲關。荼毒生民，萬裏朱殷。漢擊匈奴，雖得陰山，枕骸徧野，功不補患。\n蒼蒼蒸民，誰無父母？提攜捧負，畏其不壽。誰無兄弟？如足如手。誰無夫婦？如賓如友。生也何恩，殺之何咎？其存其沒，家莫聞知。人或有言，將信將疑。悁悁心目，寤寐見之。布奠傾觴，哭望天涯。天地爲愁，草木悽悲。弔祭不至，精魂無依。必有凶年，人其流離。嗚呼噫嘻！時耶命耶？從古如斯！爲之奈何？守在四夷。',
  },
  {
    id: 'classic-tang-libai-yuhanjingzhoushu',
    category: 'classic',
    dynasty: 'tang',
    title: '與韓荊州書',
    source: '李白',
    description: '《古文觀止》收錄之經典名篇，作者為李白。',
    content: '白聞天下談士相聚而言曰：“生不用封萬戶侯，但願一識韓荊州。”何令人之景慕，一至於此耶！豈不以有周公之風，躬吐握之事，使海內豪俊，奔走而歸之，一登龍門，則聲價十倍！所以龍蟠鳳逸之士，皆欲收名定價於君侯。願君侯不以富貴而驕之、寒賤而忽之，則三千之中有毛遂，使白得穎脫而出，即其人焉。\n白，隴西布衣，流落楚、漢。十五好劍術，遍幹諸侯。三十成文章，歷抵卿相。雖長不滿七尺，而心雄萬夫。皆王公大人許與氣義。此疇曩心跡，安敢不盡於君侯哉！\n君侯製作侔神明，德行動天地，筆參造化，學究天人。幸願開張心顏，不以長揖見拒。必若接之以高宴，縱之以清談，請日試萬言，倚馬可待。今天下以君侯爲文章之司命，人物之權衡，一經品題，便作佳士。而君侯何惜階前盈尺之地，不使白揚眉吐氣，激昂青雲耶？\n昔王子師爲豫州，未下車，即闢荀慈明，既下車，又闢孔文舉；山濤作冀州，甄拔三十餘人，或爲侍中、尚書，先代所美。而君侯亦薦一嚴協律，入爲祕書郎，中間崔宗之、房習祖、黎昕、許瑩之徒，或以才名見知，或以清白見賞。白每觀其銜恩撫躬，忠義奮發，以此感激，知君侯推赤心於諸賢腹中，所以不歸他人，而願委身國士。儻急難有用，敢效微軀。\n且人非堯舜，誰能盡善？白謨猷籌畫，安能自矜？至於製作，積成卷軸，則欲塵穢視聽。恐雕蟲小技，不合大人。若賜觀芻蕘，請給紙墨，兼之書人，然後退掃閒軒，繕寫呈上。庶青萍、結綠，長價於薛、卞之門。幸惟下流，大開獎飾，惟君侯圖之。',
  },
  {
    id: 'classic-tang-luobinwang-weixujingyetaowuzhaoxi',
    category: 'classic',
    dynasty: 'tang',
    title: '爲徐敬業討武曌檄',
    source: '駱賓王',
    description: '《古文觀止》收錄之經典名篇，作者為駱賓王。',
    content: '僞臨朝武氏者，性非和順，地實寒微。昔充太宗下陳，曾以更衣入侍。洎乎晚節，穢亂春宮。潛隱先帝之私，陰圖後房之嬖。入門見嫉，蛾眉不肯讓人；掩袖工讒，狐媚偏能惑主。踐元后於翬翟，陷吾君於聚麀。加以虺蜴爲心，豺狼成性，近狎邪僻，殘害忠良，殺姊屠兄，弒君鴆母。人神之所同嫉，天地之所不容。猶復包藏禍心，窺竊神器。君之愛子，幽之於別宮；賊之宗盟，委之以重任。嗚呼！霍子孟之不作，朱虛侯之已亡。燕啄皇孫，知漢祚之將盡；龍漦帝后，識夏庭之遽衰。\n敬業皇唐舊臣，公侯冢子。奉先帝之成業，荷本朝之厚恩。宋微子之興悲，良有以也；袁君山之流涕，豈徒然哉！是用氣憤風雲，志安社稷。因天下之失望，順宇內之推心，爰舉義旗，以清妖孽。南連百越，北盡三河，鐵騎成羣，玉軸相接。海陵紅粟，倉儲之積靡窮；江浦黃旗，匡復之功何遠？班聲動而北風起，劍氣衝而南鬥平。喑嗚則山嶽崩頹，叱吒則風雲變色。以此制敵，何敵不摧；以此圖功，何功不克！\n公等或家傳漢爵，或地協周親，或膺重寄於爪牙，或受顧命於宣室。言猶在耳，忠豈忘心？一抔之土未乾，六尺之孤何託？倘能轉禍爲福，送往事居，共立勤王之勳，無廢舊君之命，凡諸爵賞，同指山河。若其眷戀窮城，徘徊歧路，坐昧先幾之兆，必貽後至之誅。請看今日之域中，竟是誰家之天下！移檄州郡，鹹使知聞。',
  },
  {
    id: 'classic-tang-hanyu-huolinjie',
    category: 'classic',
    dynasty: 'tang',
    title: '獲麟解',
    source: '韓愈',
    description: '《古文觀止》收錄之經典名篇，作者為韓愈。',
    content: '麟之爲靈，昭昭也。詠於《詩》，書於《春秋》，雜出於傳記百家之書，雖婦人小子皆知其爲祥也。\n然麟之爲物，不畜於家，不恆有於天下。其爲形也不類，非若馬牛犬豕豺狼麋鹿然。然則雖有麟，不可知其爲麟也。\n角者吾知其爲牛，鬣者吾知其爲馬，犬豕豺狼麋鹿，吾知其爲犬豕豺狼麋鹿。惟麟也，不可知。不可知，則其謂之不祥也亦宜。雖然，麟之出，必有聖人在乎位。麟爲聖人出也。聖人者，必知麟，麟之果不爲不祥也。\n又曰：“麟之所以爲麟者，以德不以形。”若麟之出不待聖人，則謂之不祥也亦宜。',
  },
]
